var items = {
  "block.minecraft.acacia_button": "Akazienhulzgnobf",
  "block.minecraft.acacia_door": "Akazienhulzdüe",
  "block.minecraft.acacia_fence": "Akazienhulzzaun",
  "block.minecraft.acacia_fence_gate": "Akazienhulzzauntor",
  "block.minecraft.acacia_hanging_sign": "Aggazienhängeschildle",
  "block.minecraft.acacia_leaves": "Akazienlaab",
  "block.minecraft.acacia_log": "Akazienschdamm",
  "block.minecraft.acacia_planks": "Akazienhulzbredda",
  "block.minecraft.acacia_pressure_plate": "Akazienhulzdruggbladdn",
  "block.minecraft.acacia_sapling": "Akaziensetzling",
  "block.minecraft.acacia_shelf": "Acacia Shelf",
  "block.minecraft.acacia_sign": "Akazienhulzschild",
  "block.minecraft.acacia_slab": "Akazienhulzschdufn",
  "block.minecraft.acacia_stairs": "Akazienhulzdrebbn",
  "block.minecraft.acacia_trapdoor": "Akazienhulzfalldüe",
  "block.minecraft.acacia_wall_hanging_sign": "Aggazienwandhängeschlidle",
  "block.minecraft.acacia_wall_sign": "Akazienhulzwandschild",
  "block.minecraft.acacia_wood": "Akazienhulz",
  "block.minecraft.activator_rail": "Agdivierungsschiene",
  "block.minecraft.air": "Lufd",
  "block.minecraft.allium": "Ziealauch",
  "block.minecraft.amethyst_block": "Amethysdblogg",
  "block.minecraft.amethyst_cluster": "Amethysdhaafn",
  "block.minecraft.ancient_debris": "Antiga Schrodt",
  "block.minecraft.andesite": "Andesidd",
  "block.minecraft.andesite_slab": "Andesiddschdufn",
  "block.minecraft.andesite_stairs": "Andesidddrebbn",
  "block.minecraft.andesite_wall": "Andesiddmaua",
  "block.minecraft.anvil": "Amboß",
  "block.minecraft.attached_melon_stem": "Küabisrankn",
  "block.minecraft.attached_pumpkin_stem": "Küabisrankn",
  "block.minecraft.azalea": "Azalee",
  "block.minecraft.azalea_leaves": "Azaleenlaab",
  "block.minecraft.azure_bluet": "Boazellansteanchn",
  "block.minecraft.bamboo": "Bambus",
  "block.minecraft.bamboo_block": "Bambusblogg",
  "block.minecraft.bamboo_button": "Bambusknöpfle",
  "block.minecraft.bamboo_door": "Bambuspfortn",
  "block.minecraft.bamboo_fence": "Bambuszäunla",
  "block.minecraft.bamboo_fence_gate": "Bambuszaunpfortn",
  "block.minecraft.bamboo_hanging_sign": "Bambushängeschildle",
  "block.minecraft.bamboo_mosaic": "Bambusmosaigg",
  "block.minecraft.bamboo_mosaic_slab": "Bambusmosaiggstufn",
  "block.minecraft.bamboo_mosaic_stairs": "Bambusmosaiktreppn",
  "block.minecraft.bamboo_planks": "Bambusbredder",
  "block.minecraft.bamboo_pressure_plate": "Bambusdruggpladdn",
  "block.minecraft.bamboo_sapling": "Bambussprösslin",
  "block.minecraft.bamboo_shelf": "Bamboo Shelf",
  "block.minecraft.bamboo_sign": "Bambusschildle",
  "block.minecraft.bamboo_slab": "Bambusstufn",
  "block.minecraft.bamboo_stairs": "Bambusstrebbn",
  "block.minecraft.bamboo_trapdoor": "Bambusfalldür",
  "block.minecraft.bamboo_wall_hanging_sign": "Bambuswandhängeschildle",
  "block.minecraft.bamboo_wall_sign": "Bambuswandschildle",
  "block.minecraft.banner.base.black": "Vollkumma schwoarzes Föid",
  "block.minecraft.banner.base.blue": "Vollkumma blaues Föid",
  "block.minecraft.banner.base.brown": "Vollkumma broaunes Föid",
  "block.minecraft.banner.base.cyan": "Vollkumma dürgises Föid",
  "block.minecraft.banner.base.gray": "Vollkumma graues Föid",
  "block.minecraft.banner.base.green": "Vollkumma grines Föid",
  "block.minecraft.banner.base.light_blue": "Vollkumma hellblaues Föid",
  "block.minecraft.banner.base.light_gray": "Vollkumma hellgraues Föid",
  "block.minecraft.banner.base.lime": "Vollkumma hellgrines Föid",
  "block.minecraft.banner.base.magenta": "Vollkumma magenda Föid",
  "block.minecraft.banner.base.orange": "Vollkumma oranges Föid",
  "block.minecraft.banner.base.pink": "Vollkumma bingges Föid",
  "block.minecraft.banner.base.purple": "Vollkumma violeddes Föid",
  "block.minecraft.banner.base.red": "Vollkumma roudes Föid",
  "block.minecraft.banner.base.white": "Vollkumma woaßes Föid",
  "block.minecraft.banner.base.yellow": "Vollkumma gelbes Föid",
  "block.minecraft.banner.border.black": "Schwoaza Board",
  "block.minecraft.banner.border.blue": "Blaua Board",
  "block.minecraft.banner.border.brown": "Broauna Board",
  "block.minecraft.banner.border.cyan": "Dürgisa Board",
  "block.minecraft.banner.border.gray": "Graua Board",
  "block.minecraft.banner.border.green": "Grina Board",
  "block.minecraft.banner.border.light_blue": "Hellblaua Board",
  "block.minecraft.banner.border.light_gray": "Hellgraua Board",
  "block.minecraft.banner.border.lime": "Hellgrina Board",
  "block.minecraft.banner.border.magenta": "Magenda Board",
  "block.minecraft.banner.border.orange": "Oranga Board",
  "block.minecraft.banner.border.pink": "Bingga Board",
  "block.minecraft.banner.border.purple": "Violedda Board",
  "block.minecraft.banner.border.red": "Rouda Board",
  "block.minecraft.banner.border.white": "Woaßa Board",
  "block.minecraft.banner.border.yellow": "Gelba Board",
  "block.minecraft.banner.bricks.black": "Föid schwoarz gmauert",
  "block.minecraft.banner.bricks.blue": "Föid blau gmauert",
  "block.minecraft.banner.bricks.brown": "Föid broaun gmauert",
  "block.minecraft.banner.bricks.cyan": "Föid dürgis gmauert",
  "block.minecraft.banner.bricks.gray": "Föid grau gmauert",
  "block.minecraft.banner.bricks.green": "Föid grin gmauert",
  "block.minecraft.banner.bricks.light_blue": "Föid hellblau gmauert",
  "block.minecraft.banner.bricks.light_gray": "Föid hellgrau gmauert",
  "block.minecraft.banner.bricks.lime": "Föid hellgrin gmauert",
  "block.minecraft.banner.bricks.magenta": "Föid magenda gmauert",
  "block.minecraft.banner.bricks.orange": "Föid orange gmauert",
  "block.minecraft.banner.bricks.pink": "Föid bingg gmauert",
  "block.minecraft.banner.bricks.purple": "Föid violedd gmauert",
  "block.minecraft.banner.bricks.red": "Föid roud gmauert",
  "block.minecraft.banner.bricks.white": "Föid woaß gmauert",
  "block.minecraft.banner.bricks.yellow": "Föid gelb gmauert",
  "block.minecraft.banner.circle.black": "Schwoaze Kugl",
  "block.minecraft.banner.circle.blue": "Blaue Kugl",
  "block.minecraft.banner.circle.brown": "Broaune Kugl",
  "block.minecraft.banner.circle.cyan": "Dürgise Kugl",
  "block.minecraft.banner.circle.gray": "Graue Kugl",
  "block.minecraft.banner.circle.green": "Grine Kugl",
  "block.minecraft.banner.circle.light_blue": "Hellblaue Kugl",
  "block.minecraft.banner.circle.light_gray": "Hellgraue Kugl",
  "block.minecraft.banner.circle.lime": "Hellgrine Kugl",
  "block.minecraft.banner.circle.magenta": "Magenda Kugl",
  "block.minecraft.banner.circle.orange": "Orange Kugl",
  "block.minecraft.banner.circle.pink": "Bingge Kugl",
  "block.minecraft.banner.circle.purple": "Violedde Kugl",
  "block.minecraft.banner.circle.red": "Roude Kugl",
  "block.minecraft.banner.circle.white": "Woaße Kugl",
  "block.minecraft.banner.circle.yellow": "Gelbe Kugl",
  "block.minecraft.banner.creeper.black": "Schwoaza Creeper",
  "block.minecraft.banner.creeper.blue": "Blaua Creeper",
  "block.minecraft.banner.creeper.brown": "Broauna Creeper",
  "block.minecraft.banner.creeper.cyan": "Dürgisa Creeper",
  "block.minecraft.banner.creeper.gray": "Graua Creeper",
  "block.minecraft.banner.creeper.green": "Grina Creeper",
  "block.minecraft.banner.creeper.light_blue": "Hellblaua Creeper",
  "block.minecraft.banner.creeper.light_gray": "Hellgraua Creeper",
  "block.minecraft.banner.creeper.lime": "Hellgrina Creeper",
  "block.minecraft.banner.creeper.magenta": "Magenda Creeper",
  "block.minecraft.banner.creeper.orange": "Oranga Creeper",
  "block.minecraft.banner.creeper.pink": "Bingga Creeper",
  "block.minecraft.banner.creeper.purple": "Violedda Creeper",
  "block.minecraft.banner.creeper.red": "Rouda Creeper",
  "block.minecraft.banner.creeper.white": "Woaßa Creeper",
  "block.minecraft.banner.creeper.yellow": "Gelba Creeper",
  "block.minecraft.banner.cross.black": "Schwoazes Andreasgraits",
  "block.minecraft.banner.cross.blue": "Blaues Andreasgraits",
  "block.minecraft.banner.cross.brown": "Broaunes Andreasgraits",
  "block.minecraft.banner.cross.cyan": "Dürgises Andreasgraits",
  "block.minecraft.banner.cross.gray": "Graues Andreasgraits",
  "block.minecraft.banner.cross.green": "Grines Andreasgraits",
  "block.minecraft.banner.cross.light_blue": "Hellblaues Andreasgraits",
  "block.minecraft.banner.cross.light_gray": "Hellgraues Andreasgraits",
  "block.minecraft.banner.cross.lime": "Hellgrines Andreasgraits",
  "block.minecraft.banner.cross.magenta": "Magenda Andreasgraits",
  "block.minecraft.banner.cross.orange": "Oranges Andreasgraits",
  "block.minecraft.banner.cross.pink": "Bingges Andreasgraits",
  "block.minecraft.banner.cross.purple": "Violeddes Andreasgraits",
  "block.minecraft.banner.cross.red": "Roudes Andreasgraits",
  "block.minecraft.banner.cross.white": "Woaßes Andreasgraits",
  "block.minecraft.banner.cross.yellow": "Gelbes Andreasgraits",
  "block.minecraft.banner.curly_border.black": "Schwoaza Schbicklboard",
  "block.minecraft.banner.curly_border.blue": "Blaua Schbicklboard",
  "block.minecraft.banner.curly_border.brown": "Broauna Schbicklboard",
  "block.minecraft.banner.curly_border.cyan": "Dürgisa Schbicklboard",
  "block.minecraft.banner.curly_border.gray": "Graua Schbicklboard",
  "block.minecraft.banner.curly_border.green": "Grina Schbicklboard",
  "block.minecraft.banner.curly_border.light_blue": "Hellblaua Schbicklboard",
  "block.minecraft.banner.curly_border.light_gray": "Hellgraua Schbicklboard",
  "block.minecraft.banner.curly_border.lime": "Hellgrina Schbicklboard",
  "block.minecraft.banner.curly_border.magenta": "Magenda Schbicklboard",
  "block.minecraft.banner.curly_border.orange": "Oranga Schbicklboard",
  "block.minecraft.banner.curly_border.pink": "Bingga Schbicklboard",
  "block.minecraft.banner.curly_border.purple": "Violedda Schbicklboard",
  "block.minecraft.banner.curly_border.red": "Rouda Schbicklboard",
  "block.minecraft.banner.curly_border.white": "Woaßa Schbicklboard",
  "block.minecraft.banner.curly_border.yellow": "Gelba Schbicklboard",
  "block.minecraft.banner.diagonal_left.black": "Schwoaz schrechlings deeld",
  "block.minecraft.banner.diagonal_left.blue": "Blau schrechlings deeld",
  "block.minecraft.banner.diagonal_left.brown": "Broaun schrechlings deeld",
  "block.minecraft.banner.diagonal_left.cyan": "Dürgis schrechlings deeld",
  "block.minecraft.banner.diagonal_left.gray": "Grau schrechlings deeld",
  "block.minecraft.banner.diagonal_left.green": "Grin schrechlings deeld",
  "block.minecraft.banner.diagonal_left.light_blue": "Hellblau schrechlings deeld",
  "block.minecraft.banner.diagonal_left.light_gray": "Hellgrau schrechlings deeld",
  "block.minecraft.banner.diagonal_left.lime": "Hellgrin schrechlings deeld",
  "block.minecraft.banner.diagonal_left.magenta": "Magenda schrechlings deeld",
  "block.minecraft.banner.diagonal_left.orange": "Orange schrechlings deeld",
  "block.minecraft.banner.diagonal_left.pink": "Bingg schrechlings deeld",
  "block.minecraft.banner.diagonal_left.purple": "Violedd schrechlings deeld",
  "block.minecraft.banner.diagonal_left.red": "Roud schrechlings deeld",
  "block.minecraft.banner.diagonal_left.white": "Woaß schrechlings deeld",
  "block.minecraft.banner.diagonal_left.yellow": "Gelb schrechlings deeld",
  "block.minecraft.banner.diagonal_right.black": "Schwoaz schrechrechds deeld",
  "block.minecraft.banner.diagonal_right.blue": "Blau schrechrechds deeld",
  "block.minecraft.banner.diagonal_right.brown": "Broaun schrechrechds deeld",
  "block.minecraft.banner.diagonal_right.cyan": "Dürgis schrechrechds deeld",
  "block.minecraft.banner.diagonal_right.gray": "Grau schrechrechds deeld",
  "block.minecraft.banner.diagonal_right.green": "Grin schrechrechds deeld",
  "block.minecraft.banner.diagonal_right.light_blue": "Hellblau schrechrechds deeld",
  "block.minecraft.banner.diagonal_right.light_gray": "Hellgrau schrechrechds deeld",
  "block.minecraft.banner.diagonal_right.lime": "Hellgrin schrechrechds deeld",
  "block.minecraft.banner.diagonal_right.magenta": "Magenda schrechrechds deeld",
  "block.minecraft.banner.diagonal_right.orange": "Orange schrechrechds deeld",
  "block.minecraft.banner.diagonal_right.pink": "Bingg schrechrechds deeld",
  "block.minecraft.banner.diagonal_right.purple": "Violedd schrechrechds deeld",
  "block.minecraft.banner.diagonal_right.red": "Roud schrechrechds deeld",
  "block.minecraft.banner.diagonal_right.white": "Woaß schrechrechds deeld",
  "block.minecraft.banner.diagonal_right.yellow": "Gelb schrechrechds deeld",
  "block.minecraft.banner.diagonal_up_left.black": "Schwoaz schrechrechds deeld (Invertiert)",
  "block.minecraft.banner.diagonal_up_left.blue": "Blau schrechrechds deeld (Invertiert)",
  "block.minecraft.banner.diagonal_up_left.brown": "Broaun schrechrechds deeld (Invertiert)",
  "block.minecraft.banner.diagonal_up_left.cyan": "Dürgis schrechrechds deeld (Invertiert)",
  "block.minecraft.banner.diagonal_up_left.gray": "Grau schrechrechds deeld (Invertiert)",
  "block.minecraft.banner.diagonal_up_left.green": "Grin schrechrechds deeld (Invertiert)",
  "block.minecraft.banner.diagonal_up_left.light_blue": "Hellblau schrechrechds deeld (Invertiert)",
  "block.minecraft.banner.diagonal_up_left.light_gray": "Hellgrau schrechrechds deeld (Invertiert)",
  "block.minecraft.banner.diagonal_up_left.lime": "Hellgrin schrechrechds deeld (Invertiert)",
  "block.minecraft.banner.diagonal_up_left.magenta": "Magenda schrechrechds deeld (Invertiert)",
  "block.minecraft.banner.diagonal_up_left.orange": "Orange schrechrechds deeld (Invertiert)",
  "block.minecraft.banner.diagonal_up_left.pink": "Bingg schrechrechds deeld (Invertiert)",
  "block.minecraft.banner.diagonal_up_left.purple": "Violedd schrechrechds deeld (Invertiert)",
  "block.minecraft.banner.diagonal_up_left.red": "Roud schrechrechds deeld (Invertiert)",
  "block.minecraft.banner.diagonal_up_left.white": "Woaß schrechrechds deeld (Invertiert)",
  "block.minecraft.banner.diagonal_up_left.yellow": "Gelb schrechrechds deeld (Invertiert)",
  "block.minecraft.banner.diagonal_up_right.black": "Schwoaz schrechlings deeld (Invertiert)",
  "block.minecraft.banner.diagonal_up_right.blue": "Blau schrechlings deeld (Invertiert)",
  "block.minecraft.banner.diagonal_up_right.brown": "Broaun schrechlings deeld (Invertiert)",
  "block.minecraft.banner.diagonal_up_right.cyan": "Dürgis schrechlings deeld (Invertiert)",
  "block.minecraft.banner.diagonal_up_right.gray": "Grau schrechlings deeld (Invertiert)",
  "block.minecraft.banner.diagonal_up_right.green": "Grin schrechlings deeld (Invertiert)",
  "block.minecraft.banner.diagonal_up_right.light_blue": "Hellblau schrechlings deeld (Invertiert)",
  "block.minecraft.banner.diagonal_up_right.light_gray": "Hellgrau schrechlings deeld (Invertiert)",
  "block.minecraft.banner.diagonal_up_right.lime": "Hellgrin schrechlings deeld (Invertiert)",
  "block.minecraft.banner.diagonal_up_right.magenta": "Magenda schrechlings deeld (Invertiert)",
  "block.minecraft.banner.diagonal_up_right.orange": "Orange schrechlings deeld (Invertiert)",
  "block.minecraft.banner.diagonal_up_right.pink": "Bingg schrechlings deeld (Invertiert)",
  "block.minecraft.banner.diagonal_up_right.purple": "Violedd schrechlings deeld (Invertiert)",
  "block.minecraft.banner.diagonal_up_right.red": "Roud schrechlings deeld (Invertiert)",
  "block.minecraft.banner.diagonal_up_right.white": "Woaß schrechlings deeld (Invertiert)",
  "block.minecraft.banner.diagonal_up_right.yellow": "Gelb schrechlings deeld (Invertiert)",
  "block.minecraft.banner.flow.black": "Black Flow",
  "block.minecraft.banner.flow.blue": "Blue Flow",
  "block.minecraft.banner.flow.brown": "Brown Flow",
  "block.minecraft.banner.flow.cyan": "Cyan Flow",
  "block.minecraft.banner.flow.gray": "Gray Flow",
  "block.minecraft.banner.flow.green": "Green Flow",
  "block.minecraft.banner.flow.light_blue": "Light Blue Flow",
  "block.minecraft.banner.flow.light_gray": "Light Gray Flow",
  "block.minecraft.banner.flow.lime": "Lime Flow",
  "block.minecraft.banner.flow.magenta": "Magenta Flow",
  "block.minecraft.banner.flow.orange": "Orange Flow",
  "block.minecraft.banner.flow.pink": "Pink Flow",
  "block.minecraft.banner.flow.purple": "Purple Flow",
  "block.minecraft.banner.flow.red": "Red Flow",
  "block.minecraft.banner.flow.white": "White Flow",
  "block.minecraft.banner.flow.yellow": "Yellow Flow",
  "block.minecraft.banner.flower.black": "Schwoaze Bluma",
  "block.minecraft.banner.flower.blue": "Blaue Bluma",
  "block.minecraft.banner.flower.brown": "Broaune Bluma",
  "block.minecraft.banner.flower.cyan": "Dürgise Bluma",
  "block.minecraft.banner.flower.gray": "Graue Bluma",
  "block.minecraft.banner.flower.green": "Grine Bluma",
  "block.minecraft.banner.flower.light_blue": "Hellblaue Bluma",
  "block.minecraft.banner.flower.light_gray": "Hellgraue Bluma",
  "block.minecraft.banner.flower.lime": "Hellgrine Bluma",
  "block.minecraft.banner.flower.magenta": "Magenda Bluma",
  "block.minecraft.banner.flower.orange": "Orange Bluma",
  "block.minecraft.banner.flower.pink": "Bingge Bluma",
  "block.minecraft.banner.flower.purple": "Violedde Bluma",
  "block.minecraft.banner.flower.red": "Roude Bluma",
  "block.minecraft.banner.flower.white": "Woaße Bluma",
  "block.minecraft.banner.flower.yellow": "Gelbe Bluma",
  "block.minecraft.banner.globe.black": "Schwoaza Globus",
  "block.minecraft.banner.globe.blue": "Blaua Globus",
  "block.minecraft.banner.globe.brown": "Broauna Globus",
  "block.minecraft.banner.globe.cyan": "Dürgisa Globus",
  "block.minecraft.banner.globe.gray": "Graua Globus",
  "block.minecraft.banner.globe.green": "Grina Globus",
  "block.minecraft.banner.globe.light_blue": "Hellblaua Globus",
  "block.minecraft.banner.globe.light_gray": "Hellgraua Globus",
  "block.minecraft.banner.globe.lime": "Hellgrina Globus",
  "block.minecraft.banner.globe.magenta": "Magenda Globus",
  "block.minecraft.banner.globe.orange": "Oranga Globus",
  "block.minecraft.banner.globe.pink": "Bingga Globus",
  "block.minecraft.banner.globe.purple": "Violedda Globus",
  "block.minecraft.banner.globe.red": "Rouda Globus",
  "block.minecraft.banner.globe.white": "Woaßa Globus",
  "block.minecraft.banner.globe.yellow": "Gelba Globus",
  "block.minecraft.banner.gradient.black": "Schwoaza Farbverlaaf",
  "block.minecraft.banner.gradient.blue": "Blaua Farbverlaaf",
  "block.minecraft.banner.gradient.brown": "Broauna Farbverlaaf",
  "block.minecraft.banner.gradient.cyan": "Dürgisa Farbverlaaf",
  "block.minecraft.banner.gradient.gray": "Graua Farbverlaaf",
  "block.minecraft.banner.gradient.green": "Grina Farbverlaaf",
  "block.minecraft.banner.gradient.light_blue": "Hellblaua Farbverlaaf",
  "block.minecraft.banner.gradient.light_gray": "Hellgraua Farbverlaaf",
  "block.minecraft.banner.gradient.lime": "Hellgrina Farbverlaaf",
  "block.minecraft.banner.gradient.magenta": "Magenda Farbverlaaf",
  "block.minecraft.banner.gradient.orange": "Oranga Farbverlaaf",
  "block.minecraft.banner.gradient.pink": "Bingga Farbverlaaf",
  "block.minecraft.banner.gradient.purple": "Violedda Farbverlaaf",
  "block.minecraft.banner.gradient.red": "Rouda Farbverlaaf",
  "block.minecraft.banner.gradient.white": "Woaßa Farbverlaaf",
  "block.minecraft.banner.gradient.yellow": "Gelba Farbverlaaf",
  "block.minecraft.banner.gradient_up.black": "Schwoaza Farbverlaaf (Invertiert)",
  "block.minecraft.banner.gradient_up.blue": "Blaua Farbverlaaf (Invertiert)",
  "block.minecraft.banner.gradient_up.brown": "Broauna Farbverlaaf (Invertiert)",
  "block.minecraft.banner.gradient_up.cyan": "Dürgisa Farbverlaaf (Invertiert)",
  "block.minecraft.banner.gradient_up.gray": "Graua Farbverlaaf (Invertiert)",
  "block.minecraft.banner.gradient_up.green": "Grina Farbverlaaf (Invertiert)",
  "block.minecraft.banner.gradient_up.light_blue": "Hellblaua Farbverlaaf (Invertiert)",
  "block.minecraft.banner.gradient_up.light_gray": "Hellgraua Farbverlaaf (Invertiert)",
  "block.minecraft.banner.gradient_up.lime": "Hellgrina Farbverlaaf (Invertiert)",
  "block.minecraft.banner.gradient_up.magenta": "Magenda Farbverlaaf (Invertiert)",
  "block.minecraft.banner.gradient_up.orange": "Oranga Farbverlaaf (Invertiert)",
  "block.minecraft.banner.gradient_up.pink": "Bingga Farbverlaaf (Invertiert)",
  "block.minecraft.banner.gradient_up.purple": "Violedda Farbverlaaf (Invertiert)",
  "block.minecraft.banner.gradient_up.red": "Rouda Farbverlaaf (Invertiert)",
  "block.minecraft.banner.gradient_up.white": "Woaßa Farbverlaaf (Invertiert)",
  "block.minecraft.banner.gradient_up.yellow": "Gelba Farbverlaaf (Invertiert)",
  "block.minecraft.banner.guster.black": "Black Guster",
  "block.minecraft.banner.guster.blue": "Blue Guster",
  "block.minecraft.banner.guster.brown": "Brown Guster",
  "block.minecraft.banner.guster.cyan": "Cyan Guster",
  "block.minecraft.banner.guster.gray": "Gray Guster",
  "block.minecraft.banner.guster.green": "Green Guster",
  "block.minecraft.banner.guster.light_blue": "Light Blue Guster",
  "block.minecraft.banner.guster.light_gray": "Light Gray Guster",
  "block.minecraft.banner.guster.lime": "Lime Guster",
  "block.minecraft.banner.guster.magenta": "Magenta Guster",
  "block.minecraft.banner.guster.orange": "Orange Guster",
  "block.minecraft.banner.guster.pink": "Pink Guster",
  "block.minecraft.banner.guster.purple": "Purple Guster",
  "block.minecraft.banner.guster.red": "Red Guster",
  "block.minecraft.banner.guster.white": "White Guster",
  "block.minecraft.banner.guster.yellow": "Yellow Guster",
  "block.minecraft.banner.half_horizontal.black": "Ouwa schwoarz deeld",
  "block.minecraft.banner.half_horizontal.blue": "Ouwa blau deeld",
  "block.minecraft.banner.half_horizontal.brown": "Ouwa broaun deeld",
  "block.minecraft.banner.half_horizontal.cyan": "Ouwa dürgis deeld",
  "block.minecraft.banner.half_horizontal.gray": "Ouwa grau deeld",
  "block.minecraft.banner.half_horizontal.green": "Ouwa grin deeld",
  "block.minecraft.banner.half_horizontal.light_blue": "Ouwa hellblau deeld",
  "block.minecraft.banner.half_horizontal.light_gray": "Ouwa hellgrau deeld",
  "block.minecraft.banner.half_horizontal.lime": "Ouwa hellgrin deeld",
  "block.minecraft.banner.half_horizontal.magenta": "Ouwa magenda deeld",
  "block.minecraft.banner.half_horizontal.orange": "Ouwa orange deeld",
  "block.minecraft.banner.half_horizontal.pink": "Ouwa bingg deeld",
  "block.minecraft.banner.half_horizontal.purple": "Ouwa violedd deeld",
  "block.minecraft.banner.half_horizontal.red": "Ouwa roud deeld",
  "block.minecraft.banner.half_horizontal.white": "Ouwa woaß deeld",
  "block.minecraft.banner.half_horizontal.yellow": "Ouwa gelb deeld",
  "block.minecraft.banner.half_horizontal_bottom.black": "Undn schwoarz deeld",
  "block.minecraft.banner.half_horizontal_bottom.blue": "Undn blau deeld",
  "block.minecraft.banner.half_horizontal_bottom.brown": "Undn broaun deeld",
  "block.minecraft.banner.half_horizontal_bottom.cyan": "Undn dürgis deeld",
  "block.minecraft.banner.half_horizontal_bottom.gray": "Undn grau deeld",
  "block.minecraft.banner.half_horizontal_bottom.green": "Undn grin deeld",
  "block.minecraft.banner.half_horizontal_bottom.light_blue": "Undn hellblau deeld",
  "block.minecraft.banner.half_horizontal_bottom.light_gray": "Undn hellgrau deeld",
  "block.minecraft.banner.half_horizontal_bottom.lime": "Undn hellgrin deeld",
  "block.minecraft.banner.half_horizontal_bottom.magenta": "Undn magenda deeld",
  "block.minecraft.banner.half_horizontal_bottom.orange": "Undn orange deeld",
  "block.minecraft.banner.half_horizontal_bottom.pink": "Undn bingg deeld",
  "block.minecraft.banner.half_horizontal_bottom.purple": "Undn violedd deeld",
  "block.minecraft.banner.half_horizontal_bottom.red": "Undn roud deeld",
  "block.minecraft.banner.half_horizontal_bottom.white": "Undn woaß deeld",
  "block.minecraft.banner.half_horizontal_bottom.yellow": "Undn gelb deeld",
  "block.minecraft.banner.half_vertical.black": "Rechds schwoarz gschbaldn",
  "block.minecraft.banner.half_vertical.blue": "Rechds blau gschbaldn",
  "block.minecraft.banner.half_vertical.brown": "Rechds broaun gschbaldn",
  "block.minecraft.banner.half_vertical.cyan": "Rechds dürgis gschbaldn",
  "block.minecraft.banner.half_vertical.gray": "Rechds grau gschbaldn",
  "block.minecraft.banner.half_vertical.green": "Rechds grin gschbaldn",
  "block.minecraft.banner.half_vertical.light_blue": "Rechds hellblau gschbaldn",
  "block.minecraft.banner.half_vertical.light_gray": "Rechds hellgrau gschbaldn",
  "block.minecraft.banner.half_vertical.lime": "Rechds hellgrin gschbaldn",
  "block.minecraft.banner.half_vertical.magenta": "Rechds magenda gschbaldn",
  "block.minecraft.banner.half_vertical.orange": "Rechds orange gschbaldn",
  "block.minecraft.banner.half_vertical.pink": "Rechds bingg gschbaldn",
  "block.minecraft.banner.half_vertical.purple": "Rechds violedd gschbaldn",
  "block.minecraft.banner.half_vertical.red": "Rechds roud gschbaldn",
  "block.minecraft.banner.half_vertical.white": "Rechds woaß gschbaldn",
  "block.minecraft.banner.half_vertical.yellow": "Rechds gelb gschbaldn",
  "block.minecraft.banner.half_vertical_right.black": "Lings schwoarz gschbaldn",
  "block.minecraft.banner.half_vertical_right.blue": "Lings blau gschbaldn",
  "block.minecraft.banner.half_vertical_right.brown": "Lings broaun gschbaldn",
  "block.minecraft.banner.half_vertical_right.cyan": "Lings dürgis gschbaldn",
  "block.minecraft.banner.half_vertical_right.gray": "Lings grau gschbaldn",
  "block.minecraft.banner.half_vertical_right.green": "Lings grin gschbaldn",
  "block.minecraft.banner.half_vertical_right.light_blue": "Lings hellblau gschbaldn",
  "block.minecraft.banner.half_vertical_right.light_gray": "Lings hellgrau gschbaldn",
  "block.minecraft.banner.half_vertical_right.lime": "Lings hellgrin gschbaldn",
  "block.minecraft.banner.half_vertical_right.magenta": "Lings magenda gschbaldn",
  "block.minecraft.banner.half_vertical_right.orange": "Lings orange gschbaldn",
  "block.minecraft.banner.half_vertical_right.pink": "Lings bingg gschbaldn",
  "block.minecraft.banner.half_vertical_right.purple": "Lings violedd gschbaldn",
  "block.minecraft.banner.half_vertical_right.red": "Lings roud gschbaldn",
  "block.minecraft.banner.half_vertical_right.white": "Lings woaß gschbaldn",
  "block.minecraft.banner.half_vertical_right.yellow": "Lings gelb gschbaldn",
  "block.minecraft.banner.mojang.black": "Schwoazes Mojang-Logo",
  "block.minecraft.banner.mojang.blue": "Blaues Mojang-Logo",
  "block.minecraft.banner.mojang.brown": "Broaunes Mojang-Logo",
  "block.minecraft.banner.mojang.cyan": "Dürgises Mojang-Logo",
  "block.minecraft.banner.mojang.gray": "Graues Mojang-Logo",
  "block.minecraft.banner.mojang.green": "Grines Mojang-Logo",
  "block.minecraft.banner.mojang.light_blue": "Hellblaues Mojang-Logo",
  "block.minecraft.banner.mojang.light_gray": "Hellgraues Mojang-Logo",
  "block.minecraft.banner.mojang.lime": "Hellgrines Mojang-Logo",
  "block.minecraft.banner.mojang.magenta": "Magenda Mojang-Logo",
  "block.minecraft.banner.mojang.orange": "Oranges Mojang-Logo",
  "block.minecraft.banner.mojang.pink": "Bingges Mojang-Logo",
  "block.minecraft.banner.mojang.purple": "Violeddes Mojang-Logo",
  "block.minecraft.banner.mojang.red": "Roudes Mojang-Logo",
  "block.minecraft.banner.mojang.white": "Woaßes Mojang-Logo",
  "block.minecraft.banner.mojang.yellow": "Gelbes Mojang-Logo",
  "block.minecraft.banner.piglin.black": "Schwoaze Schnauzn",
  "block.minecraft.banner.piglin.blue": "Blaue Schnauzn",
  "block.minecraft.banner.piglin.brown": "Broaune Schnauzn",
  "block.minecraft.banner.piglin.cyan": "Dürgise Schnauzn",
  "block.minecraft.banner.piglin.gray": "Graue Schnauzn",
  "block.minecraft.banner.piglin.green": "Grine Schnauzn",
  "block.minecraft.banner.piglin.light_blue": "Hellblaue Schnauzn",
  "block.minecraft.banner.piglin.light_gray": "Hellgraue Schnauzn",
  "block.minecraft.banner.piglin.lime": "Hellgrine Schnauzn",
  "block.minecraft.banner.piglin.magenta": "Magenda Schnauzn",
  "block.minecraft.banner.piglin.orange": "Orange Schnauzn",
  "block.minecraft.banner.piglin.pink": "Bingge Schnauzn",
  "block.minecraft.banner.piglin.purple": "Violedde Schnauzn",
  "block.minecraft.banner.piglin.red": "Roude Schnauzn",
  "block.minecraft.banner.piglin.white": "Woaße Schnauzn",
  "block.minecraft.banner.piglin.yellow": "Gelbe Schnauzn",
  "block.minecraft.banner.rhombus.black": "Schwoaze Raude",
  "block.minecraft.banner.rhombus.blue": "Blaue Raude",
  "block.minecraft.banner.rhombus.brown": "Broaune Raude",
  "block.minecraft.banner.rhombus.cyan": "Dürgise Raude",
  "block.minecraft.banner.rhombus.gray": "Graue Raude",
  "block.minecraft.banner.rhombus.green": "Grine Raude",
  "block.minecraft.banner.rhombus.light_blue": "Hellblaue Raude",
  "block.minecraft.banner.rhombus.light_gray": "Hellgraue Raude",
  "block.minecraft.banner.rhombus.lime": "Hellgrine Raude",
  "block.minecraft.banner.rhombus.magenta": "Magenda Raude",
  "block.minecraft.banner.rhombus.orange": "Orange Raude",
  "block.minecraft.banner.rhombus.pink": "Bingge Raude",
  "block.minecraft.banner.rhombus.purple": "Violedde Raude",
  "block.minecraft.banner.rhombus.red": "Roude Raude",
  "block.minecraft.banner.rhombus.white": "Woaße Raude",
  "block.minecraft.banner.rhombus.yellow": "Gelbe Raude",
  "block.minecraft.banner.skull.black": "Schwoaza Schedl",
  "block.minecraft.banner.skull.blue": "Blaua Schedl",
  "block.minecraft.banner.skull.brown": "Broauna Schedl",
  "block.minecraft.banner.skull.cyan": "Dürgisa Schedl",
  "block.minecraft.banner.skull.gray": "Graua Schedl",
  "block.minecraft.banner.skull.green": "Grina Schedl",
  "block.minecraft.banner.skull.light_blue": "Hellblaua Schedl",
  "block.minecraft.banner.skull.light_gray": "Hellgraua Schedl",
  "block.minecraft.banner.skull.lime": "Hellgrina Schedl",
  "block.minecraft.banner.skull.magenta": "Magenda Schedl",
  "block.minecraft.banner.skull.orange": "Oranga Schedl",
  "block.minecraft.banner.skull.pink": "Bingga Schedl",
  "block.minecraft.banner.skull.purple": "Violedda Schedl",
  "block.minecraft.banner.skull.red": "Rouda Schedl",
  "block.minecraft.banner.skull.white": "Woaßa Schedl",
  "block.minecraft.banner.skull.yellow": "Gelba Schedl",
  "block.minecraft.banner.small_stripes.black": "Via schwoarze Pfohle",
  "block.minecraft.banner.small_stripes.blue": "Via blaue Pfohle",
  "block.minecraft.banner.small_stripes.brown": "Via broaune Pfohle",
  "block.minecraft.banner.small_stripes.cyan": "Via dürgise Pfohle",
  "block.minecraft.banner.small_stripes.gray": "Via graue Pfohle",
  "block.minecraft.banner.small_stripes.green": "Via grine Pfohle",
  "block.minecraft.banner.small_stripes.light_blue": "Via hellblaue Pfohle",
  "block.minecraft.banner.small_stripes.light_gray": "Via hellgraue Pfohle",
  "block.minecraft.banner.small_stripes.lime": "Via hellgrine Pfohle",
  "block.minecraft.banner.small_stripes.magenta": "Via magenda Pfohle",
  "block.minecraft.banner.small_stripes.orange": "Via orange Pfohle",
  "block.minecraft.banner.small_stripes.pink": "Via bingge Pfohle",
  "block.minecraft.banner.small_stripes.purple": "Via violedde Pfohle",
  "block.minecraft.banner.small_stripes.red": "Via roude Pfohle",
  "block.minecraft.banner.small_stripes.white": "Via woaße Pfohle",
  "block.minecraft.banner.small_stripes.yellow": "Via gelbe Pfohle",
  "block.minecraft.banner.square_bottom_left.black": "Schwoazes rechdes Ünnareck",
  "block.minecraft.banner.square_bottom_left.blue": "Blaues rechdes Ünnareck",
  "block.minecraft.banner.square_bottom_left.brown": "Broaunes rechdes Ünnareck",
  "block.minecraft.banner.square_bottom_left.cyan": "Dürgises rechdes Ünnareck",
  "block.minecraft.banner.square_bottom_left.gray": "Graues rechdes Ünnareck",
  "block.minecraft.banner.square_bottom_left.green": "Grines rechdes Ünnareck",
  "block.minecraft.banner.square_bottom_left.light_blue": "Hellblaues rechdes Ünnareck",
  "block.minecraft.banner.square_bottom_left.light_gray": "Hellgraues rechdes Ünnareck",
  "block.minecraft.banner.square_bottom_left.lime": "Hellgrines rechdes Ünnareck",
  "block.minecraft.banner.square_bottom_left.magenta": "Magenda rechdes Ünnareck",
  "block.minecraft.banner.square_bottom_left.orange": "Oranges rechdes Ünnareck",
  "block.minecraft.banner.square_bottom_left.pink": "Bingges rechdes Ünnareck",
  "block.minecraft.banner.square_bottom_left.purple": "Violeddes rechdes Ünnareck",
  "block.minecraft.banner.square_bottom_left.red": "Roudes rechdes Ünnareck",
  "block.minecraft.banner.square_bottom_left.white": "Woaßes rechdes Ünnareck",
  "block.minecraft.banner.square_bottom_left.yellow": "Gelbes rechdes Ünnareck",
  "block.minecraft.banner.square_bottom_right.black": "Schwoazes linges Ünnareck",
  "block.minecraft.banner.square_bottom_right.blue": "Blaues linges Ünnareck",
  "block.minecraft.banner.square_bottom_right.brown": "Broaunes linges Ünnareck",
  "block.minecraft.banner.square_bottom_right.cyan": "Dürgises linges Ünnareck",
  "block.minecraft.banner.square_bottom_right.gray": "Graues linges Ünnareck",
  "block.minecraft.banner.square_bottom_right.green": "Grines linges Ünnareck",
  "block.minecraft.banner.square_bottom_right.light_blue": "Hellblaues linges Ünnareck",
  "block.minecraft.banner.square_bottom_right.light_gray": "Hellgraues linges Ünnareck",
  "block.minecraft.banner.square_bottom_right.lime": "Hellgrines linges Ünnareck",
  "block.minecraft.banner.square_bottom_right.magenta": "Magenda linges Ünnareck",
  "block.minecraft.banner.square_bottom_right.orange": "Oranges linges Ünnareck",
  "block.minecraft.banner.square_bottom_right.pink": "Bingges linges Ünnareck",
  "block.minecraft.banner.square_bottom_right.purple": "Violeddes linges Ünnareck",
  "block.minecraft.banner.square_bottom_right.red": "Roudes linges Ünnareck",
  "block.minecraft.banner.square_bottom_right.white": "Woaßes linges Ünnareck",
  "block.minecraft.banner.square_bottom_right.yellow": "Gelbes linges Ünnareck",
  "block.minecraft.banner.square_top_left.black": "Schwoazes rechdes Ouwaeck",
  "block.minecraft.banner.square_top_left.blue": "Blaues rechdes Ouwaeck",
  "block.minecraft.banner.square_top_left.brown": "Broaunes rechdes Ouwaeck",
  "block.minecraft.banner.square_top_left.cyan": "Dürgises rechdes Ouwaeck",
  "block.minecraft.banner.square_top_left.gray": "Graues rechdes Ouwaeck",
  "block.minecraft.banner.square_top_left.green": "Grines rechdes Ouwaeck",
  "block.minecraft.banner.square_top_left.light_blue": "Hellblaues rechdes Ouwaeck",
  "block.minecraft.banner.square_top_left.light_gray": "Hellgraues rechdes Ouwaeck",
  "block.minecraft.banner.square_top_left.lime": "Hellgrines rechdes Ouwaeck",
  "block.minecraft.banner.square_top_left.magenta": "Magenda rechdes Ouwaeck",
  "block.minecraft.banner.square_top_left.orange": "Oranges rechdes Ouwaeck",
  "block.minecraft.banner.square_top_left.pink": "Bingges rechdes Ouwaeck",
  "block.minecraft.banner.square_top_left.purple": "Violeddes rechdes Ouwaeck",
  "block.minecraft.banner.square_top_left.red": "Roudes rechdes Ouwaeck",
  "block.minecraft.banner.square_top_left.white": "Woaßes rechdes Ouwaeck",
  "block.minecraft.banner.square_top_left.yellow": "Gelbes rechdes Ouwaeck",
  "block.minecraft.banner.square_top_right.black": "Schwoazes linges Ouwaeck",
  "block.minecraft.banner.square_top_right.blue": "Blaues linges Ouwaeck",
  "block.minecraft.banner.square_top_right.brown": "Broaunes linges Ouwaeck",
  "block.minecraft.banner.square_top_right.cyan": "Dürgises linges Ouwaeck",
  "block.minecraft.banner.square_top_right.gray": "Graues linges Ouwaeck",
  "block.minecraft.banner.square_top_right.green": "Grines linges Ouwaeck",
  "block.minecraft.banner.square_top_right.light_blue": "Hellblaues linges Ouwaeck",
  "block.minecraft.banner.square_top_right.light_gray": "Hellgraues linges Ouwaeck",
  "block.minecraft.banner.square_top_right.lime": "Hellgrines linges Ouwaeck",
  "block.minecraft.banner.square_top_right.magenta": "Magenda linges Ouwaeck",
  "block.minecraft.banner.square_top_right.orange": "Oranges linges Ouwaeck",
  "block.minecraft.banner.square_top_right.pink": "Bingges linges Ouwaeck",
  "block.minecraft.banner.square_top_right.purple": "Violeddes linges Ouwaeck",
  "block.minecraft.banner.square_top_right.red": "Roudes linges Ouwaeck",
  "block.minecraft.banner.square_top_right.white": "Woaßes linges Ouwaeck",
  "block.minecraft.banner.square_top_right.yellow": "Gelbes linges Ouwaeck",
  "block.minecraft.banner.straight_cross.black": "Schwoazes Graits",
  "block.minecraft.banner.straight_cross.blue": "Blaues Graits",
  "block.minecraft.banner.straight_cross.brown": "Broaunes Graits",
  "block.minecraft.banner.straight_cross.cyan": "Dürgises Graits",
  "block.minecraft.banner.straight_cross.gray": "Graues Graits",
  "block.minecraft.banner.straight_cross.green": "Grines Graits",
  "block.minecraft.banner.straight_cross.light_blue": "Hellblaues Graits",
  "block.minecraft.banner.straight_cross.light_gray": "Hellgraues Graits",
  "block.minecraft.banner.straight_cross.lime": "Hellgrines Graits",
  "block.minecraft.banner.straight_cross.magenta": "Magenda Graits",
  "block.minecraft.banner.straight_cross.orange": "Oranges Graits",
  "block.minecraft.banner.straight_cross.pink": "Bingges Graits",
  "block.minecraft.banner.straight_cross.purple": "Violeddes Graits",
  "block.minecraft.banner.straight_cross.red": "Roudes Graits",
  "block.minecraft.banner.straight_cross.white": "Woaßes Graits",
  "block.minecraft.banner.straight_cross.yellow": "Gelbes Graits",
  "block.minecraft.banner.stripe_bottom.black": "Schwoaza Bannerfiaß",
  "block.minecraft.banner.stripe_bottom.blue": "Blaua Bannerfiaß",
  "block.minecraft.banner.stripe_bottom.brown": "Broauna Bannerfiaß",
  "block.minecraft.banner.stripe_bottom.cyan": "Dürgisa Bannerfiaß",
  "block.minecraft.banner.stripe_bottom.gray": "Graua Bannerfiaß",
  "block.minecraft.banner.stripe_bottom.green": "Grina Bannerfiaß",
  "block.minecraft.banner.stripe_bottom.light_blue": "Hellblaua Bannerfiaß",
  "block.minecraft.banner.stripe_bottom.light_gray": "Hellgraua Bannerfiaß",
  "block.minecraft.banner.stripe_bottom.lime": "Hellgrina Bannerfiaß",
  "block.minecraft.banner.stripe_bottom.magenta": "Magenda Bannerfiaß",
  "block.minecraft.banner.stripe_bottom.orange": "Oranga Bannerfiaß",
  "block.minecraft.banner.stripe_bottom.pink": "Bingga Bannerfiaß",
  "block.minecraft.banner.stripe_bottom.purple": "Violedda Bannerfiaß",
  "block.minecraft.banner.stripe_bottom.red": "Rouda Bannerfiaß",
  "block.minecraft.banner.stripe_bottom.white": "Woaßa Bannerfiaß",
  "block.minecraft.banner.stripe_bottom.yellow": "Gelba Bannerfiaß",
  "block.minecraft.banner.stripe_center.black": "Schwoaza Pfohl",
  "block.minecraft.banner.stripe_center.blue": "Blaua Pfohl",
  "block.minecraft.banner.stripe_center.brown": "Broauna Pfohl",
  "block.minecraft.banner.stripe_center.cyan": "Dürgisa Pfohl",
  "block.minecraft.banner.stripe_center.gray": "Graua Pfohl",
  "block.minecraft.banner.stripe_center.green": "Grina Pfohl",
  "block.minecraft.banner.stripe_center.light_blue": "Hellblaua Pfohl",
  "block.minecraft.banner.stripe_center.light_gray": "Hellgraua Pfohl",
  "block.minecraft.banner.stripe_center.lime": "Hellgrina Pfohl",
  "block.minecraft.banner.stripe_center.magenta": "Magenda Pfohl",
  "block.minecraft.banner.stripe_center.orange": "Oranga Pfohl",
  "block.minecraft.banner.stripe_center.pink": "Bingga Pfohl",
  "block.minecraft.banner.stripe_center.purple": "Violedda Pfohl",
  "block.minecraft.banner.stripe_center.red": "Rouda Pfohl",
  "block.minecraft.banner.stripe_center.white": "Woaßa Pfohl",
  "block.minecraft.banner.stripe_center.yellow": "Gelba Pfohl",
  "block.minecraft.banner.stripe_downleft.black": "Schwoaza Schrechlingsbalkn",
  "block.minecraft.banner.stripe_downleft.blue": "Blaua Schrechlingsbalkn",
  "block.minecraft.banner.stripe_downleft.brown": "Broauna Schrechlingsbalkn",
  "block.minecraft.banner.stripe_downleft.cyan": "Dürgisa Schrechlingsbalkn",
  "block.minecraft.banner.stripe_downleft.gray": "Graua Schrechlingsbalkn",
  "block.minecraft.banner.stripe_downleft.green": "Grina Schrechlingsbalkn",
  "block.minecraft.banner.stripe_downleft.light_blue": "Hellblaua Schrechlingsbalkn",
  "block.minecraft.banner.stripe_downleft.light_gray": "Hellgraua Schrechlingsbalkn",
  "block.minecraft.banner.stripe_downleft.lime": "Hellgrina Schrechlingsbalkn",
  "block.minecraft.banner.stripe_downleft.magenta": "Magenda Schrechlingsbalkn",
  "block.minecraft.banner.stripe_downleft.orange": "Oranga Schrechlingsbalkn",
  "block.minecraft.banner.stripe_downleft.pink": "Bingga Schrechlingsbalkn",
  "block.minecraft.banner.stripe_downleft.purple": "Violedda Schrechlingsbalkn",
  "block.minecraft.banner.stripe_downleft.red": "Rouda Schrechlingsbalkn",
  "block.minecraft.banner.stripe_downleft.white": "Woaßa Schrechlingsbalkn",
  "block.minecraft.banner.stripe_downleft.yellow": "Gelba Schrechlingsbalkn",
  "block.minecraft.banner.stripe_downright.black": "Schwoaza Schrechbalkn",
  "block.minecraft.banner.stripe_downright.blue": "Blaua Schrechbalkn",
  "block.minecraft.banner.stripe_downright.brown": "Broauna Schrechbalkn",
  "block.minecraft.banner.stripe_downright.cyan": "Dürgisa Schrechbalkn",
  "block.minecraft.banner.stripe_downright.gray": "Graua Schrechbalkn",
  "block.minecraft.banner.stripe_downright.green": "Grina Schrechbalkn",
  "block.minecraft.banner.stripe_downright.light_blue": "Hellblaua Schrechbalkn",
  "block.minecraft.banner.stripe_downright.light_gray": "Hellgraua Schrechbalkn",
  "block.minecraft.banner.stripe_downright.lime": "Hellgrina Schrechbalkn",
  "block.minecraft.banner.stripe_downright.magenta": "Magenda Schrechbalkn",
  "block.minecraft.banner.stripe_downright.orange": "Oranga Schrechbalkn",
  "block.minecraft.banner.stripe_downright.pink": "Bingga Schrechbalkn",
  "block.minecraft.banner.stripe_downright.purple": "Violedda Schrechbalkn",
  "block.minecraft.banner.stripe_downright.red": "Rouda Schrechbalkn",
  "block.minecraft.banner.stripe_downright.white": "Woaßa Schrechbalkn",
  "block.minecraft.banner.stripe_downright.yellow": "Gelba Schrechbalkn",
  "block.minecraft.banner.stripe_left.black": "Schwoaze rechde Flankn",
  "block.minecraft.banner.stripe_left.blue": "Blaue rechde Flankn",
  "block.minecraft.banner.stripe_left.brown": "Broaune rechde Flankn",
  "block.minecraft.banner.stripe_left.cyan": "Dürgise rechde Flankn",
  "block.minecraft.banner.stripe_left.gray": "Graue rechde Flankn",
  "block.minecraft.banner.stripe_left.green": "Grine rechde Flankn",
  "block.minecraft.banner.stripe_left.light_blue": "Hellblaue rechde Flankn",
  "block.minecraft.banner.stripe_left.light_gray": "Hellgraue rechde Flankn",
  "block.minecraft.banner.stripe_left.lime": "Hellgrine rechde Flankn",
  "block.minecraft.banner.stripe_left.magenta": "Magenda rechde Flankn",
  "block.minecraft.banner.stripe_left.orange": "Orange rechde Flankn",
  "block.minecraft.banner.stripe_left.pink": "Bingge rechde Flankn",
  "block.minecraft.banner.stripe_left.purple": "Violedde rechde Flankn",
  "block.minecraft.banner.stripe_left.red": "Roude rechde Flankn",
  "block.minecraft.banner.stripe_left.white": "Woaße rechde Flankn",
  "block.minecraft.banner.stripe_left.yellow": "Gelbe rechde Flankn",
  "block.minecraft.banner.stripe_middle.black": "Schwoaza Balkn",
  "block.minecraft.banner.stripe_middle.blue": "Blaua Balkn",
  "block.minecraft.banner.stripe_middle.brown": "Broauna Balkn",
  "block.minecraft.banner.stripe_middle.cyan": "Dürgisa Balkn",
  "block.minecraft.banner.stripe_middle.gray": "Graua Balkn",
  "block.minecraft.banner.stripe_middle.green": "Grina Balkn",
  "block.minecraft.banner.stripe_middle.light_blue": "Hellblaua Balkn",
  "block.minecraft.banner.stripe_middle.light_gray": "Hellgraua Balkn",
  "block.minecraft.banner.stripe_middle.lime": "Hellgrina Balkn",
  "block.minecraft.banner.stripe_middle.magenta": "Magenda Balkn",
  "block.minecraft.banner.stripe_middle.orange": "Oranga Balkn",
  "block.minecraft.banner.stripe_middle.pink": "Bingga Balkn",
  "block.minecraft.banner.stripe_middle.purple": "Violedda Balkn",
  "block.minecraft.banner.stripe_middle.red": "Rouda Balkn",
  "block.minecraft.banner.stripe_middle.white": "Woaßa Balkn",
  "block.minecraft.banner.stripe_middle.yellow": "Gelba Balkn",
  "block.minecraft.banner.stripe_right.black": "Schwoaze linge Flankn",
  "block.minecraft.banner.stripe_right.blue": "Blaue linge Flankn",
  "block.minecraft.banner.stripe_right.brown": "Broaune linge Flankn",
  "block.minecraft.banner.stripe_right.cyan": "Dürgise linge Flankn",
  "block.minecraft.banner.stripe_right.gray": "Graue linge Flankn",
  "block.minecraft.banner.stripe_right.green": "Grine linge Flankn",
  "block.minecraft.banner.stripe_right.light_blue": "Hellblaue linge Flankn",
  "block.minecraft.banner.stripe_right.light_gray": "Hellgraue linge Flankn",
  "block.minecraft.banner.stripe_right.lime": "Hellgrine linge Flankn",
  "block.minecraft.banner.stripe_right.magenta": "Magenda linge Flankn",
  "block.minecraft.banner.stripe_right.orange": "Orange linge Flankn",
  "block.minecraft.banner.stripe_right.pink": "Bingge linge Flankn",
  "block.minecraft.banner.stripe_right.purple": "Violedde linge Flankn",
  "block.minecraft.banner.stripe_right.red": "Roude linge Flankn",
  "block.minecraft.banner.stripe_right.white": "Woaße linge Flankn",
  "block.minecraft.banner.stripe_right.yellow": "Gelbe linge Flankn",
  "block.minecraft.banner.stripe_top.black": "Schwoazes Bannerhaad",
  "block.minecraft.banner.stripe_top.blue": "Blaues Bannerhaad",
  "block.minecraft.banner.stripe_top.brown": "Broaunes Bannerhaad",
  "block.minecraft.banner.stripe_top.cyan": "Dürgises Bannerhaad",
  "block.minecraft.banner.stripe_top.gray": "Graues Bannerhaad",
  "block.minecraft.banner.stripe_top.green": "Grines Bannerhaad",
  "block.minecraft.banner.stripe_top.light_blue": "Hellblaues Bannerhaad",
  "block.minecraft.banner.stripe_top.light_gray": "Hellgraues Bannerhaad",
  "block.minecraft.banner.stripe_top.lime": "Hellgrines Bannerhaad",
  "block.minecraft.banner.stripe_top.magenta": "Magenda Bannerhaad",
  "block.minecraft.banner.stripe_top.orange": "Oranges Bannerhaad",
  "block.minecraft.banner.stripe_top.pink": "Bingges Bannerhaad",
  "block.minecraft.banner.stripe_top.purple": "Violeddes Bannerhaad",
  "block.minecraft.banner.stripe_top.red": "Roudes Bannerhaad",
  "block.minecraft.banner.stripe_top.white": "Woaßes Bannerhaad",
  "block.minecraft.banner.stripe_top.yellow": "Gelbes Bannerhaad",
  "block.minecraft.banner.triangle_bottom.black": "Schwoaze hoalbe Schbitzn",
  "block.minecraft.banner.triangle_bottom.blue": "Blaue hoalbe Schbitzn",
  "block.minecraft.banner.triangle_bottom.brown": "Broaune hoalbe Schbitzn",
  "block.minecraft.banner.triangle_bottom.cyan": "Dürgise hoalbe Schbitzn",
  "block.minecraft.banner.triangle_bottom.gray": "Graue hoalbe Schbitzn",
  "block.minecraft.banner.triangle_bottom.green": "Grine hoalbe Schbitzn",
  "block.minecraft.banner.triangle_bottom.light_blue": "Hellblaue hoalbe Schbitzn",
  "block.minecraft.banner.triangle_bottom.light_gray": "Hellgraue hoalbe Schbitzn",
  "block.minecraft.banner.triangle_bottom.lime": "Hellgrine hoalbe Schbitzn",
  "block.minecraft.banner.triangle_bottom.magenta": "Magenda hoalbe Schbitzn",
  "block.minecraft.banner.triangle_bottom.orange": "Orange hoalbe Schbitzn",
  "block.minecraft.banner.triangle_bottom.pink": "Bingge hoalbe Schbitzn",
  "block.minecraft.banner.triangle_bottom.purple": "Violedde hoalbe Schbitzn",
  "block.minecraft.banner.triangle_bottom.red": "Roude hoalbe Schbitzn",
  "block.minecraft.banner.triangle_bottom.white": "Woaße hoalbe Schbitzn",
  "block.minecraft.banner.triangle_bottom.yellow": "Gelbe hoalbe Schbitzn",
  "block.minecraft.banner.triangle_top.black": "Schwoaze gstürzte hoalbe Schbitzn",
  "block.minecraft.banner.triangle_top.blue": "Blaue gstürzte hoalbe Schbitzn",
  "block.minecraft.banner.triangle_top.brown": "Broaune gstürzte hoalbe Schbitzn",
  "block.minecraft.banner.triangle_top.cyan": "Dürgise gstürzte hoalbe Schbitzn",
  "block.minecraft.banner.triangle_top.gray": "Graue gstürzte hoalbe Schbitzn",
  "block.minecraft.banner.triangle_top.green": "Grine gstürzte hoalbe Schbitzn",
  "block.minecraft.banner.triangle_top.light_blue": "Hellblaue gstürzte hoalbe Schbitzn",
  "block.minecraft.banner.triangle_top.light_gray": "Hellgraue gstürzte hoalbe Schbitzn",
  "block.minecraft.banner.triangle_top.lime": "Hellgrine gstürzte hoalbe Schbitzn",
  "block.minecraft.banner.triangle_top.magenta": "Magenda gstürzte hoalbe Schbitzn",
  "block.minecraft.banner.triangle_top.orange": "Orange gstürzte hoalbe Schbitzn",
  "block.minecraft.banner.triangle_top.pink": "Bingge gstürzte hoalbe Schbitzn",
  "block.minecraft.banner.triangle_top.purple": "Violedde gstürzte hoalbe Schbitzn",
  "block.minecraft.banner.triangle_top.red": "Roude gstürzte hoalbe Schbitzn",
  "block.minecraft.banner.triangle_top.white": "Woaße gstürzte hoalbe Schbitzn",
  "block.minecraft.banner.triangle_top.yellow": "Gelbe gstürzte hoalbe Schbitzn",
  "block.minecraft.banner.triangles_bottom.black": "Schwoaza gschpicklta Bannerfiaß",
  "block.minecraft.banner.triangles_bottom.blue": "Blaua gschpicklta Bannerfiaß",
  "block.minecraft.banner.triangles_bottom.brown": "Broauna gschpicklta Bannerfiaß",
  "block.minecraft.banner.triangles_bottom.cyan": "Dürgisa gschpicklta Bannerfiaß",
  "block.minecraft.banner.triangles_bottom.gray": "Graua gschpicklta Bannerfiaß",
  "block.minecraft.banner.triangles_bottom.green": "Grina gschpicklta Bannerfiaß",
  "block.minecraft.banner.triangles_bottom.light_blue": "Hellblaua gschpicklta Bannerfiaß",
  "block.minecraft.banner.triangles_bottom.light_gray": "Hellgraua gschpicklta Bannerfiaß",
  "block.minecraft.banner.triangles_bottom.lime": "Hellgrina gschpicklta Bannerfiaß",
  "block.minecraft.banner.triangles_bottom.magenta": "Magenda gschpicklta Bannerfiaß",
  "block.minecraft.banner.triangles_bottom.orange": "Oranga gschpicklta Bannerfiaß",
  "block.minecraft.banner.triangles_bottom.pink": "Bingga gschpicklta Bannerfiaß",
  "block.minecraft.banner.triangles_bottom.purple": "Violedda gschpicklta Bannerfiaß",
  "block.minecraft.banner.triangles_bottom.red": "Rouda gschpicklta Bannerfiaß",
  "block.minecraft.banner.triangles_bottom.white": "Woaßa gschpicklta Bannerfiaß",
  "block.minecraft.banner.triangles_bottom.yellow": "Gelba gschpicklta Bannerfiaß",
  "block.minecraft.banner.triangles_top.black": "Schwoazes gschpickltes Bannerhaad",
  "block.minecraft.banner.triangles_top.blue": "Blaues gschpickltes Bannerhaad",
  "block.minecraft.banner.triangles_top.brown": "Broaunes gschpickltes Bannerhaad",
  "block.minecraft.banner.triangles_top.cyan": "Dürgises gschpickltes Bannerhaad",
  "block.minecraft.banner.triangles_top.gray": "Graues gschpickltes Bannerhaad",
  "block.minecraft.banner.triangles_top.green": "Grines gschpickltes Bannerhaad",
  "block.minecraft.banner.triangles_top.light_blue": "Hellblaues gschpickltes Bannerhaad",
  "block.minecraft.banner.triangles_top.light_gray": "Hellgraues gschpickltes Bannerhaad",
  "block.minecraft.banner.triangles_top.lime": "Hellgrines gschpickltes Bannerhaad",
  "block.minecraft.banner.triangles_top.magenta": "Magenda gschpickltes Bannerhaad",
  "block.minecraft.banner.triangles_top.orange": "Oranges gschpickltes Bannerhaad",
  "block.minecraft.banner.triangles_top.pink": "Bingges gschpickltes Bannerhaad",
  "block.minecraft.banner.triangles_top.purple": "Violeddes gschpickltes Bannerhaad",
  "block.minecraft.banner.triangles_top.red": "Roudes gschpickltes Bannerhaad",
  "block.minecraft.banner.triangles_top.white": "Woaßes gschpickltes Bannerhaad",
  "block.minecraft.banner.triangles_top.yellow": "Gelbes gschpickltes Bannerhaad",
  "block.minecraft.barrel": "Fässla",
  "block.minecraft.barrier": "Barrier",
  "block.minecraft.basalt": "Basaldd",
  "block.minecraft.beacon": "Leuchdfeua",
  "block.minecraft.beacon.primary": "Brimäre Krafd",
  "block.minecraft.beacon.secondary": "Segundäre Krafd",
  "block.minecraft.bed.no_sleep": "Du kannsd nua noachds oda währnd eins Gewiddas schlafn",
  "block.minecraft.bed.not_safe": "Du koannst jetzadla ned schlafn, es san Monsda in dea Näh",
  "block.minecraft.bed.obstructed": "Des Bed is blockiead",
  "block.minecraft.bed.occupied": "Des Bed is bleechd",
  "block.minecraft.bed.too_far_away": "Du koannst jetzadla ned schlafn, des Bed is zu woad endfeand",
  "block.minecraft.bedrock": "Grundgeschdein",
  "block.minecraft.bee_nest": "Bienanest",
  "block.minecraft.beehive": "Bienaschdogg",
  "block.minecraft.beetroots": "Rode Bede",
  "block.minecraft.bell": "Glockn",
  "block.minecraft.big_dripleaf": "Großes Dropfbladd",
  "block.minecraft.big_dripleaf_stem": "Großa Dropfbladdstiel",
  "block.minecraft.birch_button": "Berkngnobf",
  "block.minecraft.birch_door": "Berknhulzdüe",
  "block.minecraft.birch_fence": "Berknhulzzou",
  "block.minecraft.birch_fence_gate": "Berknhulzzauntor",
  "block.minecraft.birch_hanging_sign": "Birgnhängeschildle",
  "block.minecraft.birch_leaves": "Berknlaab",
  "block.minecraft.birch_log": "Berknschdamm",
  "block.minecraft.birch_planks": "Berknhulzbredda",
  "block.minecraft.birch_pressure_plate": "Berknhulzdruggbladdn",
  "block.minecraft.birch_sapling": "Berknsetzling",
  "block.minecraft.birch_shelf": "Birch Shelf",
  "block.minecraft.birch_sign": "Berknhulzschild",
  "block.minecraft.birch_slab": "Berknhulzschdufn",
  "block.minecraft.birch_stairs": "Berknhulzdrebbn",
  "block.minecraft.birch_trapdoor": "Berknhulzfalldüe",
  "block.minecraft.birch_wall_hanging_sign": "Birgnwandhängeschildle",
  "block.minecraft.birch_wall_sign": "Berknhulzwandschild",
  "block.minecraft.birch_wood": "Berknhulz",
  "block.minecraft.black_banner": "Schwoazes Banner",
  "block.minecraft.black_bed": "Schwoazes Bedd",
  "block.minecraft.black_candle": "Schwoaze Kirza",
  "block.minecraft.black_candle_cake": "Kuchn midn schwoaza Kirza",
  "block.minecraft.black_carpet": "Schwoaza Debbich",
  "block.minecraft.black_concrete": "Schwoaza Bedon",
  "block.minecraft.black_concrete_powder": "Schwoaza Druggnbedon",
  "block.minecraft.black_glazed_terracotta": "Schwoaze gloasierde Keramig",
  "block.minecraft.black_shulker_box": "Schwoaze Shulkerkischdla",
  "block.minecraft.black_stained_glass": "Schwoazes Glos",
  "block.minecraft.black_stained_glass_pane": "Schwoaze Glosschaim",
  "block.minecraft.black_terracotta": "Schwoaze Keramig",
  "block.minecraft.black_wool": "Schwoaze Woll",
  "block.minecraft.blackstone": "Schwoazschdoi",
  "block.minecraft.blackstone_slab": "Schwoazschdoischdufn",
  "block.minecraft.blackstone_stairs": "Schwoazschdoidrebbn",
  "block.minecraft.blackstone_wall": "Schwoazschdoimaua",
  "block.minecraft.blast_furnace": "Schmelzofn",
  "block.minecraft.blue_banner": "Blaues Banner",
  "block.minecraft.blue_bed": "Blaues Bedd",
  "block.minecraft.blue_candle": "Blaua Kirza",
  "block.minecraft.blue_candle_cake": "Kuchn midn blaua Kirza",
  "block.minecraft.blue_carpet": "Blaua Debbich",
  "block.minecraft.blue_concrete": "Blaua Bedon",
  "block.minecraft.blue_concrete_powder": "Blaua Druggnbedon",
  "block.minecraft.blue_glazed_terracotta": "Blaue gloasierde Keramig",
  "block.minecraft.blue_ice": "Blauais",
  "block.minecraft.blue_orchid": "Blaua Orchideen",
  "block.minecraft.blue_shulker_box": "Blaue Shulkerkischdla",
  "block.minecraft.blue_stained_glass": "Blaues Glos",
  "block.minecraft.blue_stained_glass_pane": "Blaue Glosschaim",
  "block.minecraft.blue_terracotta": "Blaue Keramig",
  "block.minecraft.blue_wool": "Blaue Woll",
  "block.minecraft.bone_block": "Knochnblogg",
  "block.minecraft.bookshelf": "Bücharegal",
  "block.minecraft.brain_coral": "Herngralle",
  "block.minecraft.brain_coral_block": "Herngrallnblogg",
  "block.minecraft.brain_coral_fan": "Herngrallnfächa",
  "block.minecraft.brain_coral_wall_fan": "Herngrallnwandfächa",
  "block.minecraft.brewing_stand": "Brauschdand",
  "block.minecraft.brick_slab": "Zieglschdufn",
  "block.minecraft.brick_stairs": "Ziegldrebbn",
  "block.minecraft.brick_wall": "Schdoizieglmaua",
  "block.minecraft.bricks": "Ziegelstaa",
  "block.minecraft.brown_banner": "Broaunes Banner",
  "block.minecraft.brown_bed": "Broaunes Bedd",
  "block.minecraft.brown_candle": "Broauna Kirza",
  "block.minecraft.brown_candle_cake": "Kuchn midn broauna Kirza",
  "block.minecraft.brown_carpet": "Broauna Debbich",
  "block.minecraft.brown_concrete": "Broauna Bedon",
  "block.minecraft.brown_concrete_powder": "Broauna Druggnbedon",
  "block.minecraft.brown_glazed_terracotta": "Broaune gloasierde Keramig",
  "block.minecraft.brown_mushroom": "Broauna Bilz",
  "block.minecraft.brown_mushroom_block": "Broauna Bilzblogg",
  "block.minecraft.brown_shulker_box": "Broaune Shulkerkischdla",
  "block.minecraft.brown_stained_glass": "Broaunes Glos",
  "block.minecraft.brown_stained_glass_pane": "Broaune Glosschaim",
  "block.minecraft.brown_terracotta": "Broaune Keramig",
  "block.minecraft.brown_wool": "Broaune Woll",
  "block.minecraft.bubble_column": "Blasnsäule",
  "block.minecraft.bubble_coral": "Blaasngralle",
  "block.minecraft.bubble_coral_block": "Blaasngrallnblogg",
  "block.minecraft.bubble_coral_fan": "Blaasngrallnfächa",
  "block.minecraft.bubble_coral_wall_fan": "Blaasngrallnwandfächa",
  "block.minecraft.budding_amethyst": "Amethysdknosbmblogg",
  "block.minecraft.bush": "Bush",
  "block.minecraft.cactus": "Gagtus",
  "block.minecraft.cactus_flower": "Cactus Flower",
  "block.minecraft.cake": "Kuchn",
  "block.minecraft.calcite": "Galzid",
  "block.minecraft.calibrated_sculk_sensor": "Gallibrierter Sculk-Sensor",
  "block.minecraft.campfire": "Lachafeua",
  "block.minecraft.candle": "Kirza",
  "block.minecraft.candle_cake": "Kuchn midn Kirza",
  "block.minecraft.carrots": "Gelba Rübn",
  "block.minecraft.cartography_table": "Kaddndisch",
  "block.minecraft.carved_pumpkin": "G'schnitza Küabis",
  "block.minecraft.cauldron": "Gessl",
  "block.minecraft.cave_air": "Höhlnlufd",
  "block.minecraft.cave_vines": "Höhlnrankn",
  "block.minecraft.cave_vines_plant": "Höhlnranknpflanzn",
  "block.minecraft.chain": "Keddn",
  "block.minecraft.chain_command_block": "Keddn-Bfehlsblogg",
  "block.minecraft.cherry_button": "Kirschholzknöpfle",
  "block.minecraft.cherry_door": "Kirschholzpfortn",
  "block.minecraft.cherry_fence": "Kirschholzzäunla",
  "block.minecraft.cherry_fence_gate": "Kirschholzzaunpfortn",
  "block.minecraft.cherry_hanging_sign": "Kirschholzhängeschildle",
  "block.minecraft.cherry_leaves": "Kirschblädda",
  "block.minecraft.cherry_log": "Kirschholzstämmla",
  "block.minecraft.cherry_planks": "Kirschholzbredder",
  "block.minecraft.cherry_pressure_plate": "Kirschholzdruggpladdn",
  "block.minecraft.cherry_sapling": "Kirschholzsetzling",
  "block.minecraft.cherry_shelf": "Cherry Shelf",
  "block.minecraft.cherry_sign": "Kirschholzschildla",
  "block.minecraft.cherry_slab": "Kirschholzstufn",
  "block.minecraft.cherry_stairs": "Kirschholztrebbn",
  "block.minecraft.cherry_trapdoor": "Kirschholzfalldür",
  "block.minecraft.cherry_wall_hanging_sign": "Kirschholzwandhängeschild",
  "block.minecraft.cherry_wall_sign": "Kirschholzwandschild",
  "block.minecraft.cherry_wood": "Kirschholz",
  "block.minecraft.chest": "Druhe",
  "block.minecraft.chipped_anvil": "Angschlachena Amboss",
  "block.minecraft.chiseled_bookshelf": "Gestemmts Bücharegol",
  "block.minecraft.chiseled_copper": "Gmoasd's Kupfa",
  "block.minecraft.chiseled_deepslate": "Gmeißelda Diefnschiefa",
  "block.minecraft.chiseled_nether_bricks": "Gmeißelda Netherziegl",
  "block.minecraft.chiseled_polished_blackstone": "Gmeißelda poliada Schwoazschdoi",
  "block.minecraft.chiseled_quartz_block": "Gmeißelda Kwarzblogg",
  "block.minecraft.chiseled_red_sandstone": "Gmeißelda rouda Sandschdoi",
  "block.minecraft.chiseled_resin_bricks": "Chiseled Resin Bricks",
  "block.minecraft.chiseled_sandstone": "Gmeißelda Sandschdoi",
  "block.minecraft.chiseled_stone_bricks": "Gmeißelda Schdoiziegl",
  "block.minecraft.chiseled_tuff": "Gmoasd's Tuff",
  "block.minecraft.chiseled_tuff_bricks": "Gmoasde Tuffzieg",
  "block.minecraft.chorus_flower": "Chorusblüdn",
  "block.minecraft.chorus_plant": "Choruspflanzn",
  "block.minecraft.clay": "leem",
  "block.minecraft.closed_eyeblossom": "Closed Eyeblossom",
  "block.minecraft.coal_block": "Kohlblogg",
  "block.minecraft.coal_ore": "Schdoikohl",
  "block.minecraft.coarse_dirt": "Groba Dregg",
  "block.minecraft.cobbled_deepslate": "Bruchdiefnschiefa",
  "block.minecraft.cobbled_deepslate_slab": "Bruchdiefnschiefaschdufn",
  "block.minecraft.cobbled_deepslate_stairs": "Bruchdiefnschiefadrebbn",
  "block.minecraft.cobbled_deepslate_wall": "Bruchdiefnschiefamaua",
  "block.minecraft.cobblestone": "Bruchschdoi",
  "block.minecraft.cobblestone_slab": "Bruchschdoischdufn",
  "block.minecraft.cobblestone_stairs": "Bruchschdoidrebbn",
  "block.minecraft.cobblestone_wall": "Bruchschdoimaua",
  "block.minecraft.cobweb": "Spinnanetz",
  "block.minecraft.cocoa": "Kakao",
  "block.minecraft.command_block": "Bfehlsblogg",
  "block.minecraft.comparator": "Redstone-Kombaradoa",
  "block.minecraft.composter": "Komposda",
  "block.minecraft.conduit": "Aquisador",
  "block.minecraft.copper_bars": "Copper Bars",
  "block.minecraft.copper_block": "Kupfablogg",
  "block.minecraft.copper_bulb": "Kupfer Birnl",
  "block.minecraft.copper_chain": "Copper Chain",
  "block.minecraft.copper_chest": "Copper Chest",
  "block.minecraft.copper_door": "Kupfa Tia",
  "block.minecraft.copper_golem_statue": "Copper Golem Statue",
  "block.minecraft.copper_grate": "Copper Grate",
  "block.minecraft.copper_lantern": "Copper Lantern",
  "block.minecraft.copper_ore": "Kupfaätz",
  "block.minecraft.copper_torch": "Copper Torch",
  "block.minecraft.copper_trapdoor": "Copper Trapdoor",
  "block.minecraft.copper_wall_torch": "Copper Wall Torch",
  "block.minecraft.cornflower": "Kornbluma",
  "block.minecraft.cracked_deepslate_bricks": "Rissiche Diefnschiefaziegl",
  "block.minecraft.cracked_deepslate_tiles": "Rissiche Diefnschiefafliesn",
  "block.minecraft.cracked_nether_bricks": "Rissicha Netherziegl",
  "block.minecraft.cracked_polished_blackstone_bricks": "Rissicha poliada Schwoazschdoiziegl",
  "block.minecraft.cracked_stone_bricks": "Rissicha Schdoiziegl",
  "block.minecraft.crafter": "Crafter",
  "block.minecraft.crafting_table": "Werkbänk",
  "block.minecraft.creaking_heart": "Creaking Heart",
  "block.minecraft.creeper_head": "Creeperkupf",
  "block.minecraft.creeper_wall_head": "Creeper-Wandkupf",
  "block.minecraft.crimson_button": "Karmesingnobf",
  "block.minecraft.crimson_door": "Karmesindüe",
  "block.minecraft.crimson_fence": "Karmesinzaun",
  "block.minecraft.crimson_fence_gate": "Karmesinzaundüa",
  "block.minecraft.crimson_fungus": "Karmesinpilz",
  "block.minecraft.crimson_hanging_sign": "Dunkelrodshängeschildle",
  "block.minecraft.crimson_hyphae": "Karmesinhyphen",
  "block.minecraft.crimson_nylium": "Karmesin-Nezl",
  "block.minecraft.crimson_planks": "Karmesinbredda",
  "block.minecraft.crimson_pressure_plate": "Karmesindruggbladdn",
  "block.minecraft.crimson_roots": "Karmesinwurzln",
  "block.minecraft.crimson_shelf": "Crimson Shelf",
  "block.minecraft.crimson_sign": "Karmesinschild",
  "block.minecraft.crimson_slab": "Karmesinschdufn",
  "block.minecraft.crimson_stairs": "Karmesindrebbn",
  "block.minecraft.crimson_stem": "Karmesinstiel",
  "block.minecraft.crimson_trapdoor": "Karmesinfalldüe",
  "block.minecraft.crimson_wall_hanging_sign": "Dunkelrodswandschildle",
  "block.minecraft.crimson_wall_sign": "Karmesinwandschild",
  "block.minecraft.crying_obsidian": "Weinenda Obsidian",
  "block.minecraft.cut_copper": "Gschniddna Kupfablogg",
  "block.minecraft.cut_copper_slab": "Gschniddne Kupfaschdufn",
  "block.minecraft.cut_copper_stairs": "Gschniddne Kupfadrebbn",
  "block.minecraft.cut_red_sandstone": "Gschniddena rouda Sandschdoi",
  "block.minecraft.cut_red_sandstone_slab": "Gschniddene roude Sandschdoischdufn",
  "block.minecraft.cut_sandstone": "Gschniddena Sandschdoi",
  "block.minecraft.cut_sandstone_slab": "Gschniddene Sandschdoischdufn",
  "block.minecraft.cyan_banner": "Dürgises Banner",
  "block.minecraft.cyan_bed": "Dürgises Bedd",
  "block.minecraft.cyan_candle": "Dürgise Kirza",
  "block.minecraft.cyan_candle_cake": "Kuchn midn dürgisa Kirza",
  "block.minecraft.cyan_carpet": "Dürgisa Debbich",
  "block.minecraft.cyan_concrete": "Dürgisa Bedon",
  "block.minecraft.cyan_concrete_powder": "Dürgisa Druggnbedon",
  "block.minecraft.cyan_glazed_terracotta": "Dürgise gloasierde Keramig",
  "block.minecraft.cyan_shulker_box": "Dürgise Shulkerkischdla",
  "block.minecraft.cyan_stained_glass": "Dürgises Glos",
  "block.minecraft.cyan_stained_glass_pane": "Dürgise Glosschaim",
  "block.minecraft.cyan_terracotta": "Dürgise Keramig",
  "block.minecraft.cyan_wool": "Dürgise Woll",
  "block.minecraft.damaged_anvil": "Bschädigda Amboss",
  "block.minecraft.dandelion": "Lewnzohn",
  "block.minecraft.dark_oak_button": "Schwoazächahulzgnobf",
  "block.minecraft.dark_oak_door": "Schwoazächahulzdüe",
  "block.minecraft.dark_oak_fence": "Schwoazächahulzzou",
  "block.minecraft.dark_oak_fence_gate": "Schwoazächazauntor",
  "block.minecraft.dark_oak_hanging_sign": "Schwazeichenhängeschildle",
  "block.minecraft.dark_oak_leaves": "Schwoazächalaab",
  "block.minecraft.dark_oak_log": "Schwoazächaschdamm",
  "block.minecraft.dark_oak_planks": "Schwoazächahulzbredda",
  "block.minecraft.dark_oak_pressure_plate": "Schwoazächahulzdruggbladdn",
  "block.minecraft.dark_oak_sapling": "Schwoazächasetzling",
  "block.minecraft.dark_oak_shelf": "Dark Oak Shelf",
  "block.minecraft.dark_oak_sign": "Schwoazächahulzschild",
  "block.minecraft.dark_oak_slab": "Schwoazeichnhulzschdufn",
  "block.minecraft.dark_oak_stairs": "Schwoazächahulzdrebbn",
  "block.minecraft.dark_oak_trapdoor": "Schwoazächahulzfalldüe",
  "block.minecraft.dark_oak_wall_hanging_sign": "Schwazeichenwandschildle",
  "block.minecraft.dark_oak_wall_sign": "Schwoazächahulzwandschild",
  "block.minecraft.dark_oak_wood": "Schwoazächahulz",
  "block.minecraft.dark_prismarine": "Dungler Brismarin",
  "block.minecraft.dark_prismarine_slab": "Dungle Brismarinschdufn",
  "block.minecraft.dark_prismarine_stairs": "Dungle Prismarindrebbn",
  "block.minecraft.daylight_detector": "Dageslichdsensoa",
  "block.minecraft.dead_brain_coral": "Dode Herngralle",
  "block.minecraft.dead_brain_coral_block": "Doda Herngrallnblogg",
  "block.minecraft.dead_brain_coral_fan": "Doda Herngrallnfächa",
  "block.minecraft.dead_brain_coral_wall_fan": "Doda Herngrallnwandfächa",
  "block.minecraft.dead_bubble_coral": "Dode Blaasngralle",
  "block.minecraft.dead_bubble_coral_block": "Doda Blaasngrallnblogg",
  "block.minecraft.dead_bubble_coral_fan": "Doda Blaasngrallnfächa",
  "block.minecraft.dead_bubble_coral_wall_fan": "Doda Blaasngrallnwandfächa",
  "block.minecraft.dead_bush": "Doda Bischl",
  "block.minecraft.dead_fire_coral": "Dode Feuagralle",
  "block.minecraft.dead_fire_coral_block": "Doda Feuagrallnblogg",
  "block.minecraft.dead_fire_coral_fan": "Doda Feuagrallnfächa",
  "block.minecraft.dead_fire_coral_wall_fan": "Doda Feuagrallnwandfächa",
  "block.minecraft.dead_horn_coral": "Dode Gweihgralle",
  "block.minecraft.dead_horn_coral_block": "Doda Gweihgrallnblogg",
  "block.minecraft.dead_horn_coral_fan": "Doda Gweihgrallnfächa",
  "block.minecraft.dead_horn_coral_wall_fan": "Doda Gweihgrallnwandfächa",
  "block.minecraft.dead_tube_coral": "Dode Orgelgralle",
  "block.minecraft.dead_tube_coral_block": "Doda Orgelgrallenblogg",
  "block.minecraft.dead_tube_coral_fan": "Doda Orgelgrallnfächa",
  "block.minecraft.dead_tube_coral_wall_fan": "Doda Orgelgrallnwandfächa",
  "block.minecraft.decorated_pot": "Dekorierds Blumentöpfla",
  "block.minecraft.deepslate": "Diefnschiefa",
  "block.minecraft.deepslate_brick_slab": "Diefnschiefazieglschdufn",
  "block.minecraft.deepslate_brick_stairs": "Diefnschiefaziegldrebbn",
  "block.minecraft.deepslate_brick_wall": "Diefnschiefazieglmaua",
  "block.minecraft.deepslate_bricks": "Diefnschiefaziegl",
  "block.minecraft.deepslate_coal_ore": "Diefnschiefa-Stoakohln",
  "block.minecraft.deepslate_copper_ore": "Diefnschiefa-Kupfaätz",
  "block.minecraft.deepslate_diamond_ore": "Diefnschiefa-Diamandätz",
  "block.minecraft.deepslate_emerald_ore": "Diefnschiefa-Smaragdätz",
  "block.minecraft.deepslate_gold_ore": "Diefnschiefa-Goaldätz",
  "block.minecraft.deepslate_iron_ore": "Diefnschiefa-Aasnätz",
  "block.minecraft.deepslate_lapis_ore": "Diefnschiefa-Labislazuliätz",
  "block.minecraft.deepslate_redstone_ore": "Diefnschiefa-Redstone-Ätz",
  "block.minecraft.deepslate_tile_slab": "Diefnschiefafliesnschdufn",
  "block.minecraft.deepslate_tile_stairs": "Diefnschiefafliesndrebbn",
  "block.minecraft.deepslate_tile_wall": "Diefnschiefafliesnmaua",
  "block.minecraft.deepslate_tiles": "Diefnschiefafliesn",
  "block.minecraft.detector_rail": "Sensorschiene",
  "block.minecraft.diamond_block": "Diormandblogg",
  "block.minecraft.diamond_ore": "Diormandätz",
  "block.minecraft.diorite": "Dioridd",
  "block.minecraft.diorite_slab": "Dioridschdufn",
  "block.minecraft.diorite_stairs": "Dioriddrebbn",
  "block.minecraft.diorite_wall": "Dioriddmaua",
  "block.minecraft.dirt": "Dregg",
  "block.minecraft.dirt_path": "Dramplpfad",
  "block.minecraft.dispenser": "Wärfa",
  "block.minecraft.dragon_egg": "Drachngaggeli",
  "block.minecraft.dragon_head": "Drachnkupf",
  "block.minecraft.dragon_wall_head": "Drachn-Wandkupf",
  "block.minecraft.dried_ghast": "Dried Ghast",
  "block.minecraft.dried_kelp_block": "Schnähblūk",
  "block.minecraft.dripstone_block": "Droapfstoablogg",
  "block.minecraft.dropper": "Spenda",
  "block.minecraft.emerald_block": "Smaragdblogg",
  "block.minecraft.emerald_ore": "Smaragdäaz",
  "block.minecraft.enchanting_table": "Zaubadisch",
  "block.minecraft.end_gateway": "Enddransidpoadal",
  "block.minecraft.end_portal": "Endpoadal",
  "block.minecraft.end_portal_frame": "Endpoadalrahmn",
  "block.minecraft.end_rod": "Endstoab",
  "block.minecraft.end_stone": "Endstaa",
  "block.minecraft.end_stone_brick_slab": "Endschdoizieglschdufn",
  "block.minecraft.end_stone_brick_stairs": "Endschdoiziegldrebbn",
  "block.minecraft.end_stone_brick_wall": "Endschdoizieglmaua",
  "block.minecraft.end_stone_bricks": "Endstoaziegl",
  "block.minecraft.ender_chest": "Enderdruhe",
  "block.minecraft.exposed_chiseled_copper": "Exposed Chiseled Copper",
  "block.minecraft.exposed_copper": "Anglaufna Kupfablogg",
  "block.minecraft.exposed_copper_bars": "Exposed Copper Bars",
  "block.minecraft.exposed_copper_bulb": "Exposed Copper Bulb",
  "block.minecraft.exposed_copper_chain": "Exposed Copper Chain",
  "block.minecraft.exposed_copper_chest": "Exposed Copper Chest",
  "block.minecraft.exposed_copper_door": "Exposed Copper Door",
  "block.minecraft.exposed_copper_golem_statue": "Exposed Copper Golem Statue",
  "block.minecraft.exposed_copper_grate": "Exposed Copper Grate",
  "block.minecraft.exposed_copper_lantern": "Exposed Copper Lantern",
  "block.minecraft.exposed_copper_trapdoor": "Exposed Copper Trapdoor",
  "block.minecraft.exposed_cut_copper": "Anglaufna gschniddna Kupfablogg",
  "block.minecraft.exposed_cut_copper_slab": "Anglaufne gschniddne Kupfaschdufn",
  "block.minecraft.exposed_cut_copper_stairs": "Anglaufne gschniddne Kupfadrebbn",
  "block.minecraft.exposed_lightning_rod": "Exposed Lightning Rod",
  "block.minecraft.farmland": "Aggaland",
  "block.minecraft.fern": "Faan",
  "block.minecraft.fire": "Feua",
  "block.minecraft.fire_coral": "Feuagralle",
  "block.minecraft.fire_coral_block": "Feuagrallnblogg",
  "block.minecraft.fire_coral_fan": "Feuagrallnfächa",
  "block.minecraft.fire_coral_wall_fan": "Feuagrallnwandfächa",
  "block.minecraft.firefly_bush": "Firefly Bush",
  "block.minecraft.fletching_table": "Bognertisch",
  "block.minecraft.flower_pot": "Blumndobf",
  "block.minecraft.flowering_azalea": "Blühnde Azalee",
  "block.minecraft.flowering_azalea_leaves": "Blühndes Azaleenlaab",
  "block.minecraft.frogspawn": "Froschlaich",
  "block.minecraft.frosted_ice": "Brüchiges Ais",
  "block.minecraft.furnace": "oufn",
  "block.minecraft.gilded_blackstone": "Goidduachzochena Schwoazschdoi",
  "block.minecraft.glass": "Glos",
  "block.minecraft.glass_pane": "Glosschaim",
  "block.minecraft.glow_lichen": "Leuchdflechdn",
  "block.minecraft.glowstone": "Leuchdstaa",
  "block.minecraft.gold_block": "Goidblogg",
  "block.minecraft.gold_ore": "Goidätz",
  "block.minecraft.golden_dandelion": "Golden Dandelion",
  "block.minecraft.granite": "Granidd",
  "block.minecraft.granite_slab": "Graniddschdufn",
  "block.minecraft.granite_stairs": "Granidddrebbn",
  "block.minecraft.granite_wall": "Graniddmaua",
  "block.minecraft.grass": "Groos",
  "block.minecraft.grass_block": "Groosblogg",
  "block.minecraft.gravel": "Kies",
  "block.minecraft.gray_banner": "Graues Banner",
  "block.minecraft.gray_bed": "Graues Bedd",
  "block.minecraft.gray_candle": "Graue Kirza",
  "block.minecraft.gray_candle_cake": "Kuchn midn graua Kirza",
  "block.minecraft.gray_carpet": "Graua Debbich",
  "block.minecraft.gray_concrete": "Graua Bedon",
  "block.minecraft.gray_concrete_powder": "Graua Druggnbedon",
  "block.minecraft.gray_glazed_terracotta": "Graue gloasierde Keramig",
  "block.minecraft.gray_shulker_box": "Graue Shulkerkischdla",
  "block.minecraft.gray_stained_glass": "Graues Glos",
  "block.minecraft.gray_stained_glass_pane": "Graue Glosschaim",
  "block.minecraft.gray_terracotta": "Graue Keramig",
  "block.minecraft.gray_wool": "Graue Woll",
  "block.minecraft.green_banner": "Grines Banner",
  "block.minecraft.green_bed": "Grines Bedd",
  "block.minecraft.green_candle": "Grina Kirza",
  "block.minecraft.green_candle_cake": "Kuchn midn grina Kirza",
  "block.minecraft.green_carpet": "Grina Debbich",
  "block.minecraft.green_concrete": "Grina Bedon",
  "block.minecraft.green_concrete_powder": "Grina Druggnbedon",
  "block.minecraft.green_glazed_terracotta": "Grine gloasierde Keramig",
  "block.minecraft.green_shulker_box": "Grine Shulkerkischdla",
  "block.minecraft.green_stained_glass": "Grines Glos",
  "block.minecraft.green_stained_glass_pane": "Grine Glosschaim",
  "block.minecraft.green_terracotta": "Grine Keramig",
  "block.minecraft.green_wool": "Grine Woll",
  "block.minecraft.grindstone": "Schleifstaa",
  "block.minecraft.hanging_roots": "Hängewuazl",
  "block.minecraft.hay_block": "Schdruabolln",
  "block.minecraft.heavy_core": "Heavy Core",
  "block.minecraft.heavy_weighted_pressure_plate": "Grobwägplattn",
  "block.minecraft.honey_block": "Honigblogg",
  "block.minecraft.honeycomb_block": "Knochnblogg",
  "block.minecraft.hopper": "Drichda",
  "block.minecraft.horn_coral": "Gweihgralle",
  "block.minecraft.horn_coral_block": "Gweihgrallnblogg",
  "block.minecraft.horn_coral_fan": "Gweihgrallnfächa",
  "block.minecraft.horn_coral_wall_fan": "Gweihgrallnwandfächa",
  "block.minecraft.ice": "Ais",
  "block.minecraft.infested_chiseled_stone_bricks": "Bfallnde gmeißelda Schdoiziegl",
  "block.minecraft.infested_cobblestone": "Bfallnda Bruchschdoi",
  "block.minecraft.infested_cracked_stone_bricks": "Bfallnde rissicha Schdoiziegl",
  "block.minecraft.infested_deepslate": "Bfallnea Diefnschiefa",
  "block.minecraft.infested_mossy_stone_bricks": "Bfallnde bmoosde Schdoiziegl",
  "block.minecraft.infested_stone": "Bfallnda Schdoi",
  "block.minecraft.infested_stone_bricks": "Bfallnde Schdoiziegl",
  "block.minecraft.iron_bars": "Aasngidder",
  "block.minecraft.iron_block": "Aasnblogg",
  "block.minecraft.iron_chain": "Iron Chain",
  "block.minecraft.iron_door": "Aasndüe",
  "block.minecraft.iron_ore": "Aasnätz",
  "block.minecraft.iron_trapdoor": "Aasnfalldüe",
  "block.minecraft.jack_o_lantern": "Küabisladern",
  "block.minecraft.jigsaw": "Veabundsblogg",
  "block.minecraft.jukebox": "Pladdnschbiela",
  "block.minecraft.jungle_button": "Droubnhulzgnobf",
  "block.minecraft.jungle_door": "Droubnhulzdüe",
  "block.minecraft.jungle_fence": "Droubnhulzzou",
  "block.minecraft.jungle_fence_gate": "Droubnhulzzauntor",
  "block.minecraft.jungle_hanging_sign": "Dschungelhängeschildle",
  "block.minecraft.jungle_leaves": "Droubnboamlaab",
  "block.minecraft.jungle_log": "Droubnboamschdamm",
  "block.minecraft.jungle_planks": "Droubnhulzbredda",
  "block.minecraft.jungle_pressure_plate": "Droubnhulzdruggbladdn",
  "block.minecraft.jungle_sapling": "Droubnboamsetzling",
  "block.minecraft.jungle_shelf": "Jungle Shelf",
  "block.minecraft.jungle_sign": "Droubnhulzschild",
  "block.minecraft.jungle_slab": "Droubnhulzschdufn",
  "block.minecraft.jungle_stairs": "Droubnhulzdrebbn",
  "block.minecraft.jungle_trapdoor": "Droubnhulzfalldüe",
  "block.minecraft.jungle_wall_hanging_sign": "Dschungelwandhängeschildle",
  "block.minecraft.jungle_wall_sign": "Droubnhulzwandschild",
  "block.minecraft.jungle_wood": "Droubnhulz",
  "block.minecraft.kelp": "Seetang",
  "block.minecraft.kelp_plant": "Seetangstängel",
  "block.minecraft.ladder": "Loidan",
  "block.minecraft.lantern": "Ladeane",
  "block.minecraft.lapis_block": "Labislazuliblogg",
  "block.minecraft.lapis_ore": "Labislazuliätz",
  "block.minecraft.large_amethyst_bud": "Große Amethysdknosb",
  "block.minecraft.large_fern": "Großa Faan",
  "block.minecraft.lava": "Lova",
  "block.minecraft.lava_cauldron": "Lovagessl",
  "block.minecraft.leaf_litter": "Leaf Litter",
  "block.minecraft.lectern": "Lesebuld",
  "block.minecraft.lever": "Hebl",
  "block.minecraft.light": "Glichdablogg",
  "block.minecraft.light_blue_banner": "Hellblaues Banner",
  "block.minecraft.light_blue_bed": "Hellblaues Bedd",
  "block.minecraft.light_blue_candle": "Hellblaua Kirza",
  "block.minecraft.light_blue_candle_cake": "Kuchn midn hellblaua Kirza",
  "block.minecraft.light_blue_carpet": "Hellblaua Debbich",
  "block.minecraft.light_blue_concrete": "Hellblaua Bedon",
  "block.minecraft.light_blue_concrete_powder": "Hellblaua Druggnbedon",
  "block.minecraft.light_blue_glazed_terracotta": "Hellblaue gloasierde Keramig",
  "block.minecraft.light_blue_shulker_box": "Hellblaue Shulkerkischdla",
  "block.minecraft.light_blue_stained_glass": "Hellblaues Glos",
  "block.minecraft.light_blue_stained_glass_pane": "Hellblaue Glosschaim",
  "block.minecraft.light_blue_terracotta": "Hellblaue Keramig",
  "block.minecraft.light_blue_wool": "Hellblaue Woll",
  "block.minecraft.light_gray_banner": "Hellgraues Banner",
  "block.minecraft.light_gray_bed": "Hellgraues Bedd",
  "block.minecraft.light_gray_candle": "Hellgraue Kirza",
  "block.minecraft.light_gray_candle_cake": "Kuchn midn hellgraua Kirza",
  "block.minecraft.light_gray_carpet": "Hellgraua Debbich",
  "block.minecraft.light_gray_concrete": "Hellgraua Bedon",
  "block.minecraft.light_gray_concrete_powder": "Hellgraua Druggnbedon",
  "block.minecraft.light_gray_glazed_terracotta": "Hellgraue gloasierde Keramig",
  "block.minecraft.light_gray_shulker_box": "Hellgraue Shulkerkischdla",
  "block.minecraft.light_gray_stained_glass": "Hellgraues Glos",
  "block.minecraft.light_gray_stained_glass_pane": "Hellgraue Glosschaim",
  "block.minecraft.light_gray_terracotta": "Hellgraue Keramig",
  "block.minecraft.light_gray_wool": "Hellgraue Woll",
  "block.minecraft.light_weighted_pressure_plate": "Fainwägplattn",
  "block.minecraft.lightning_rod": "Blidzableida",
  "block.minecraft.lilac": "Flieder",
  "block.minecraft.lily_of_the_valley": "Maiglöckchn",
  "block.minecraft.lily_pad": "Seerosnbladd",
  "block.minecraft.lime_banner": "Hellgrines Banner",
  "block.minecraft.lime_bed": "Hellgrines Bedd",
  "block.minecraft.lime_candle": "Hellgrina Kirza",
  "block.minecraft.lime_candle_cake": "Kuchn midn hellgrina Kirza",
  "block.minecraft.lime_carpet": "Hellgrina Debbich",
  "block.minecraft.lime_concrete": "Hellgrina Bedon",
  "block.minecraft.lime_concrete_powder": "Hellgrina Druggnbedon",
  "block.minecraft.lime_glazed_terracotta": "Hellgrine gloasierde Keramig",
  "block.minecraft.lime_shulker_box": "Hellgrine Shulkerkischdla",
  "block.minecraft.lime_stained_glass": "Hellgrines Glos",
  "block.minecraft.lime_stained_glass_pane": "Hellgrine Glosschaim",
  "block.minecraft.lime_terracotta": "Hellgrine Keramig",
  "block.minecraft.lime_wool": "Hellgrine Woll",
  "block.minecraft.lodestone": "Leidstoa",
  "block.minecraft.loom": "Webstuhl",
  "block.minecraft.magenta_banner": "Magenda Banner",
  "block.minecraft.magenta_bed": "Magenda Bedd",
  "block.minecraft.magenta_candle": "Magenda Kirza",
  "block.minecraft.magenta_candle_cake": "Kuchn midn magenda Kirza",
  "block.minecraft.magenta_carpet": "Magenda Debbich",
  "block.minecraft.magenta_concrete": "Magenda Bedon",
  "block.minecraft.magenta_concrete_powder": "Magenda Druggnbedon",
  "block.minecraft.magenta_glazed_terracotta": "Magenda gloasierde Keramig",
  "block.minecraft.magenta_shulker_box": "Magenda Shulkerkischdla",
  "block.minecraft.magenta_stained_glass": "Magenda Glos",
  "block.minecraft.magenta_stained_glass_pane": "Magenda Glosschaim",
  "block.minecraft.magenta_terracotta": "Magenda Keramig",
  "block.minecraft.magenta_wool": "Magenda Woll",
  "block.minecraft.magma_block": "Magmablogg",
  "block.minecraft.mangrove_button": "Mangrownknöpfla",
  "block.minecraft.mangrove_door": "Mangrowndir",
  "block.minecraft.mangrove_fence": "Mangrownzäunla",
  "block.minecraft.mangrove_fence_gate": "Mangrownzaundor",
  "block.minecraft.mangrove_hanging_sign": "Mangrownhängeschildle",
  "block.minecraft.mangrove_leaves": "Mangrownblädder",
  "block.minecraft.mangrove_log": "Mangrownstämmla",
  "block.minecraft.mangrove_planks": "Mangrownbredder",
  "block.minecraft.mangrove_pressure_plate": "Mangrowndruggbladdn",
  "block.minecraft.mangrove_propagule": "Antopfter Mangrowensetzling",
  "block.minecraft.mangrove_roots": "Mangrownwurzl",
  "block.minecraft.mangrove_shelf": "Mangrove Shelf",
  "block.minecraft.mangrove_sign": "Mangrownschildla",
  "block.minecraft.mangrove_slab": "Mangrownstufn",
  "block.minecraft.mangrove_stairs": "Mangrowntrebbn",
  "block.minecraft.mangrove_trapdoor": "Mangrownfalldür",
  "block.minecraft.mangrove_wall_hanging_sign": "Mangrownwandhängeschildle",
  "block.minecraft.mangrove_wall_sign": "Mangrownwandschildla",
  "block.minecraft.mangrove_wood": "Mangrownhulz",
  "block.minecraft.medium_amethyst_bud": "Mittläre Amethysdknosb",
  "block.minecraft.melon": "Melon",
  "block.minecraft.melon_stem": "Melonpflanzn",
  "block.minecraft.moss_block": "Moosblogg",
  "block.minecraft.moss_carpet": "Moosteppich",
  "block.minecraft.mossy_cobblestone": "Bmoosda Bruchschdoi",
  "block.minecraft.mossy_cobblestone_slab": "Bmoosde Bruchschdoischdufn",
  "block.minecraft.mossy_cobblestone_stairs": "Bmoosde Bruchschdoidrebbn",
  "block.minecraft.mossy_cobblestone_wall": "Bmoosde Bruchschdoimaua",
  "block.minecraft.mossy_stone_brick_slab": "Bmoosde Stoazieglschdufn",
  "block.minecraft.mossy_stone_brick_stairs": "Bmoosde Schdoiziegldrebbn",
  "block.minecraft.mossy_stone_brick_wall": "Bmoosde Schdoizieglmaua",
  "block.minecraft.mossy_stone_bricks": "Bmoosde Stoaziegl",
  "block.minecraft.moving_piston": "Bwegda Blogg",
  "block.minecraft.mud": "Schlamm",
  "block.minecraft.mud_brick_slab": "Schlammziechlstufn",
  "block.minecraft.mud_brick_stairs": "Schlammziechltrebbn",
  "block.minecraft.mud_brick_wall": "Schlammziechelwond",
  "block.minecraft.mud_bricks": "Schlammziechel",
  "block.minecraft.muddy_mangrove_roots": "Dreggede Mangrownwurzl",
  "block.minecraft.mushroom_stem": "Bilzschdiel",
  "block.minecraft.mycelium": "Myzl",
  "block.minecraft.nether_brick_fence": "Netherzieglzou",
  "block.minecraft.nether_brick_slab": "Netherzieglschdufn",
  "block.minecraft.nether_brick_stairs": "Netherziegldrebbn",
  "block.minecraft.nether_brick_wall": "Netherzieglmaua",
  "block.minecraft.nether_bricks": "Netherziegl",
  "block.minecraft.nether_gold_ore": "Nethergoidätz",
  "block.minecraft.nether_portal": "Netherpoadal",
  "block.minecraft.nether_quartz_ore": "Netherkwarzätz",
  "block.minecraft.nether_sprouts": "Nethersprossn",
  "block.minecraft.nether_wart": "Netherwarzn",
  "block.minecraft.nether_wart_block": "Netherwarzblogg",
  "block.minecraft.netherite_block": "Netheritblogg",
  "block.minecraft.netherrack": "Netherrack",
  "block.minecraft.note_block": "Nodnblogg",
  "block.minecraft.oak_button": "Ächagnobf",
  "block.minecraft.oak_door": "Ächahulzdüe",
  "block.minecraft.oak_fence": "Ächahulzzou",
  "block.minecraft.oak_fence_gate": "Eichnhulzzauntor",
  "block.minecraft.oak_hanging_sign": "Aichnhängeschildle",
  "block.minecraft.oak_leaves": "Ächalaab",
  "block.minecraft.oak_log": "Ächaschdamm",
  "block.minecraft.oak_planks": "Ächahulzbredda",
  "block.minecraft.oak_pressure_plate": "Ächahulzdruggbladdn",
  "block.minecraft.oak_sapling": "Ächasetzling",
  "block.minecraft.oak_shelf": "Oak Shelf",
  "block.minecraft.oak_sign": "Ächahulzschild",
  "block.minecraft.oak_slab": "Ächahulzschdufn",
  "block.minecraft.oak_stairs": "Ächahulzdrebbn",
  "block.minecraft.oak_trapdoor": "Ächahulzfalldüe",
  "block.minecraft.oak_wall_hanging_sign": "Auchnwandhängeschildla",
  "block.minecraft.oak_wall_sign": "Ächahulzwandschild",
  "block.minecraft.oak_wood": "Ächahulz",
  "block.minecraft.observer": "Bobachda",
  "block.minecraft.obsidian": "Obsidian",
  "block.minecraft.ochre_froglight": "Oggerforbenes Froschlicht",
  "block.minecraft.ominous_banner": "Unhailvolles Banna",
  "block.minecraft.open_eyeblossom": "Open Eyeblossom",
  "block.minecraft.orange_banner": "Oranges Banner",
  "block.minecraft.orange_bed": "Oranges Bedd",
  "block.minecraft.orange_candle": "Oranga Kirza",
  "block.minecraft.orange_candle_cake": "Kuchn midn oranga Kirza",
  "block.minecraft.orange_carpet": "Oranga Debbich",
  "block.minecraft.orange_concrete": "Oranga Bedon",
  "block.minecraft.orange_concrete_powder": "Oranga Druggnbedon",
  "block.minecraft.orange_glazed_terracotta": "Orange gloasierde Keramig",
  "block.minecraft.orange_shulker_box": "Orange Shulkerkischdla",
  "block.minecraft.orange_stained_glass": "Oranges Glos",
  "block.minecraft.orange_stained_glass_pane": "Orange Glosschaim",
  "block.minecraft.orange_terracotta": "Orange Keramig",
  "block.minecraft.orange_tulip": "Orange Dulbn",
  "block.minecraft.orange_wool": "Orange Woll",
  "block.minecraft.oxeye_daisy": "Magaride",
  "block.minecraft.oxidized_chiseled_copper": "Oxidized Chiseled Copper",
  "block.minecraft.oxidized_copper": "Oxidieada Kupfablogg",
  "block.minecraft.oxidized_copper_bars": "Oxidized Copper Bars",
  "block.minecraft.oxidized_copper_bulb": "Oxidized Copper Bulb",
  "block.minecraft.oxidized_copper_chain": "Oxidized Copper Chain",
  "block.minecraft.oxidized_copper_chest": "Oxidized Copper Chest",
  "block.minecraft.oxidized_copper_door": "Oxidized Copper Door",
  "block.minecraft.oxidized_copper_golem_statue": "Oxidized Copper Golem Statue",
  "block.minecraft.oxidized_copper_grate": "Oxidized Copper Grate",
  "block.minecraft.oxidized_copper_lantern": "Oxidized Copper Lantern",
  "block.minecraft.oxidized_copper_trapdoor": "Oxidized Copper Trapdoor",
  "block.minecraft.oxidized_cut_copper": "Oxidieada gschniddna Kupfablogg",
  "block.minecraft.oxidized_cut_copper_slab": "Oxidiade gschniddne Kupfaschdufn",
  "block.minecraft.oxidized_cut_copper_stairs": "Oxidiade gschniddne Kupfadrebbn",
  "block.minecraft.oxidized_lightning_rod": "Oxidized Lightning Rod",
  "block.minecraft.packed_ice": "Baggais",
  "block.minecraft.packed_mud": "Zampackder Schlamm",
  "block.minecraft.pale_hanging_moss": "Pale Hanging Moss",
  "block.minecraft.pale_moss_block": "Pale Moss Block",
  "block.minecraft.pale_moss_carpet": "Pale Moss Carpet",
  "block.minecraft.pale_oak_button": "Pale Oak Button",
  "block.minecraft.pale_oak_door": "Pale Oak Door",
  "block.minecraft.pale_oak_fence": "Pale Oak Fence",
  "block.minecraft.pale_oak_fence_gate": "Pale Oak Fence Gate",
  "block.minecraft.pale_oak_hanging_sign": "Pale Oak Hanging Sign",
  "block.minecraft.pale_oak_leaves": "Pale Oak Leaves",
  "block.minecraft.pale_oak_log": "Pale Oak Log",
  "block.minecraft.pale_oak_planks": "Pale Oak Planks",
  "block.minecraft.pale_oak_pressure_plate": "Pale Oak Pressure Plate",
  "block.minecraft.pale_oak_sapling": "Pale Oak Sapling",
  "block.minecraft.pale_oak_shelf": "Pale Oak Shelf",
  "block.minecraft.pale_oak_sign": "Pale Oak Sign",
  "block.minecraft.pale_oak_slab": "Pale Oak Slab",
  "block.minecraft.pale_oak_stairs": "Pale Oak Stairs",
  "block.minecraft.pale_oak_trapdoor": "Pale Oak Trapdoor",
  "block.minecraft.pale_oak_wall_hanging_sign": "Pale Oak Wall Hanging Sign",
  "block.minecraft.pale_oak_wall_sign": "Pale Oak Wall Sign",
  "block.minecraft.pale_oak_wood": "Pale Oak Wood",
  "block.minecraft.pearlescent_froglight": "Berlmudd Froschlicht",
  "block.minecraft.peony": "Hunnertbletarousn",
  "block.minecraft.petrified_oak_slab": "Verschdainada Eichnschdufn",
  "block.minecraft.piglin_head": "Piglinkupf",
  "block.minecraft.piglin_wall_head": "Piglinwandkupf",
  "block.minecraft.pink_banner": "Bingges Banner",
  "block.minecraft.pink_bed": "Bingges Bedd",
  "block.minecraft.pink_candle": "Bingge Kirza",
  "block.minecraft.pink_candle_cake": "Kuchn midn bingga Kirza",
  "block.minecraft.pink_carpet": "Bingga Debbich",
  "block.minecraft.pink_concrete": "Bingga Bedon",
  "block.minecraft.pink_concrete_powder": "Bingga Druggnbedon",
  "block.minecraft.pink_glazed_terracotta": "Bingge gloasierde Keramig",
  "block.minecraft.pink_petals": "Rosa Büdenbledder",
  "block.minecraft.pink_shulker_box": "Bingge Shulkerkischdla",
  "block.minecraft.pink_stained_glass": "Bingges Glos",
  "block.minecraft.pink_stained_glass_pane": "Bingge Glosschaim",
  "block.minecraft.pink_terracotta": "Bingge Keramig",
  "block.minecraft.pink_tulip": "Bingge Dulbn",
  "block.minecraft.pink_wool": "Bingge Woll",
  "block.minecraft.piston": "Kolbm",
  "block.minecraft.piston_head": "Kolbmkupf",
  "block.minecraft.pitcher_crop": "Pitcher Crop",
  "block.minecraft.pitcher_plant": "Pitcher Plant",
  "block.minecraft.player_head": "Schbielakupf",
  "block.minecraft.player_head.named": "Kupf von %s",
  "block.minecraft.player_wall_head": "Schbiela-Wandkupf",
  "block.minecraft.podzol": "Podsol",
  "block.minecraft.pointed_dripstone": "Spitza Droapfstoa",
  "block.minecraft.polished_andesite": "Poliede Andesidd",
  "block.minecraft.polished_andesite_slab": "Poliada Andesiddschdufn",
  "block.minecraft.polished_andesite_stairs": "Poliada Andesidddrebbn",
  "block.minecraft.polished_basalt": "Poliada Basald",
  "block.minecraft.polished_blackstone": "Poliada Schwoazschdoi",
  "block.minecraft.polished_blackstone_brick_slab": "Poliada Schwoazschdoizieglschdufn",
  "block.minecraft.polished_blackstone_brick_stairs": "Poliada Schwoazschdoiziegldrebbn",
  "block.minecraft.polished_blackstone_brick_wall": "Poliada Schwoazschdoizieglmaua",
  "block.minecraft.polished_blackstone_bricks": "Poliada Schwoazschdoiziegl",
  "block.minecraft.polished_blackstone_button": "Poliada Schwoazschdoignobf",
  "block.minecraft.polished_blackstone_pressure_plate": "Poliada Schwoazschdoidruggbladdn",
  "block.minecraft.polished_blackstone_slab": "Poliada Schwoazschdoischdufn",
  "block.minecraft.polished_blackstone_stairs": "Poliada Schwoazschdoidrebbn",
  "block.minecraft.polished_blackstone_wall": "Poliada Schwoazschdoimaua",
  "block.minecraft.polished_deepslate": "Poalieada Diefnschiefa",
  "block.minecraft.polished_deepslate_slab": "Poalieada Diefnschiefaschdufn",
  "block.minecraft.polished_deepslate_stairs": "Poalieade Diefnschiefadrebbn",
  "block.minecraft.polished_deepslate_wall": "Poalieade Diefnschiefamaua",
  "block.minecraft.polished_diorite": "Poliede Dioridd",
  "block.minecraft.polished_diorite_slab": "Poliada Dioridschdufn",
  "block.minecraft.polished_diorite_stairs": "Poliada Dioriddrebbn",
  "block.minecraft.polished_granite": "Poliada Granidd",
  "block.minecraft.polished_granite_slab": "Poliada Graniddschdufn",
  "block.minecraft.polished_granite_stairs": "Poliada Granidddrebbn",
  "block.minecraft.polished_tuff": "Polished Tuff",
  "block.minecraft.polished_tuff_slab": "Polished Tuff Slab",
  "block.minecraft.polished_tuff_stairs": "Polished Tuff Stairs",
  "block.minecraft.polished_tuff_wall": "Polished Tuff Wall",
  "block.minecraft.poppy": "Mōn",
  "block.minecraft.potatoes": "Eardäpfl",
  "block.minecraft.potted_acacia_sapling": "Eingetopfta Akaziensetzling",
  "block.minecraft.potted_allium": "Eingetopfta Ziealauch",
  "block.minecraft.potted_azalea_bush": "Eingetopfte Azalee",
  "block.minecraft.potted_azure_bluet": "Eingetopfta Boazellansteanchn",
  "block.minecraft.potted_bamboo": "Eingetopfta Bambus",
  "block.minecraft.potted_birch_sapling": "Eingetopfta Berknsetzling",
  "block.minecraft.potted_blue_orchid": "Eingetopfta blaua Orchideen",
  "block.minecraft.potted_brown_mushroom": "Eingetopfta broauna Bilz",
  "block.minecraft.potted_cactus": "Eingetopfta Kakdus",
  "block.minecraft.potted_cherry_sapling": "Antopfter Kirschbaumsetzling",
  "block.minecraft.potted_closed_eyeblossom": "Potted Closed Eyeblossom",
  "block.minecraft.potted_cornflower": "Eingetopfta Kornbluma",
  "block.minecraft.potted_crimson_fungus": "Eingedopfda Karmesinbilz",
  "block.minecraft.potted_crimson_roots": "Eingedopfde Karmesinwuazeln",
  "block.minecraft.potted_dandelion": "Eingetopfta Lewnzohn",
  "block.minecraft.potted_dark_oak_sapling": "Eingetopfta Schwoazächasetzling",
  "block.minecraft.potted_dead_bush": "Eingetopfta doda Bischl",
  "block.minecraft.potted_fern": "Eingetopfta Faan",
  "block.minecraft.potted_flowering_azalea_bush": "Eingetopfte blühnde Azalee",
  "block.minecraft.potted_golden_dandelion": "Potted Golden Dandelion",
  "block.minecraft.potted_jungle_sapling": "Eingetopfta Droubnboamsetzling",
  "block.minecraft.potted_lily_of_the_valley": "Eingetopfta Maiglöckchn",
  "block.minecraft.potted_mangrove_propagule": "Antopfter Mangrowensetzling",
  "block.minecraft.potted_oak_sapling": "Eingetopfta Ächasetzling",
  "block.minecraft.potted_open_eyeblossom": "Potted Open Eyeblossom",
  "block.minecraft.potted_orange_tulip": "Eingetopfta orange Dulbn",
  "block.minecraft.potted_oxeye_daisy": "Eingetopfte Magaride",
  "block.minecraft.potted_pale_oak_sapling": "Potted Pale Oak Sapling",
  "block.minecraft.potted_pink_tulip": "Eingetopfta bingge Dulbn",
  "block.minecraft.potted_poppy": "Eingetopfta Mōn",
  "block.minecraft.potted_red_mushroom": "Eingetopfta rouda Bilz",
  "block.minecraft.potted_red_tulip": "Eingetopfta roude Dulbn",
  "block.minecraft.potted_spruce_sapling": "Eingetopfta Fichdnsetzling",
  "block.minecraft.potted_torchflower": "Antopfte Faggelilien",
  "block.minecraft.potted_warped_fungus": "Eingedopfda Wirrbilz",
  "block.minecraft.potted_warped_roots": "Eingedopfde Wirrwuazeln",
  "block.minecraft.potted_white_tulip": "Eingetopfta woaßa Dulbn",
  "block.minecraft.potted_wither_rose": "Eingetopfta Witherrousn",
  "block.minecraft.powder_snow": "Bulverschnäh",
  "block.minecraft.powder_snow_cauldron": "Bulverschnähgessl",
  "block.minecraft.powered_rail": "Ontriebschiena",
  "block.minecraft.prismarine": "Brismarin",
  "block.minecraft.prismarine_brick_slab": "Brismarinziegelschdufn",
  "block.minecraft.prismarine_brick_stairs": "Prismarinziegldrebbn",
  "block.minecraft.prismarine_bricks": "Brismarinblogg",
  "block.minecraft.prismarine_slab": "Brismarinschdufn",
  "block.minecraft.prismarine_stairs": "Prismarindrebbn",
  "block.minecraft.prismarine_wall": "Brismarinmauer",
  "block.minecraft.pumpkin": "Kärwis",
  "block.minecraft.pumpkin_stem": "Küabispflanzn",
  "block.minecraft.purple_banner": "Violeddes Banner",
  "block.minecraft.purple_bed": "Violeddes Bedd",
  "block.minecraft.purple_candle": "Violedde Kirza",
  "block.minecraft.purple_candle_cake": "Kuchn midn violedda Kirza",
  "block.minecraft.purple_carpet": "Violedda Debbich",
  "block.minecraft.purple_concrete": "Violedda Bedon",
  "block.minecraft.purple_concrete_powder": "Violedda Druggnbedon",
  "block.minecraft.purple_glazed_terracotta": "Violedde gloasierde Keramig",
  "block.minecraft.purple_shulker_box": "Violedde Shulkerkischdla",
  "block.minecraft.purple_stained_glass": "Violeddes Glos",
  "block.minecraft.purple_stained_glass_pane": "Violedde Glosschaim",
  "block.minecraft.purple_terracotta": "Violedde Keramig",
  "block.minecraft.purple_wool": "Violedde Woll",
  "block.minecraft.purpur_block": "Purpurblogg",
  "block.minecraft.purpur_pillar": "Purpursäuln",
  "block.minecraft.purpur_slab": "Purpurschdufn",
  "block.minecraft.purpur_stairs": "Purpurdrebbn",
  "block.minecraft.quartz_block": "Kwarzblogg",
  "block.minecraft.quartz_bricks": "Kwarzziegl",
  "block.minecraft.quartz_pillar": "Kwarzsäuln",
  "block.minecraft.quartz_slab": "Kwarzschdufn",
  "block.minecraft.quartz_stairs": "Kwarzdrebbn",
  "block.minecraft.rail": "Schiene",
  "block.minecraft.raw_copper_block": "Rohkupfablogg",
  "block.minecraft.raw_gold_block": "Roggoidblogg",
  "block.minecraft.raw_iron_block": "Rohaasnblogg",
  "block.minecraft.red_banner": "Roudes Banner",
  "block.minecraft.red_bed": "Roudes Bedd",
  "block.minecraft.red_candle": "Roude Kirza",
  "block.minecraft.red_candle_cake": "Kuchn midn rouda Kirza",
  "block.minecraft.red_carpet": "Rouda Debbich",
  "block.minecraft.red_concrete": "Rouda Bedon",
  "block.minecraft.red_concrete_powder": "Rouda Druggnbedon",
  "block.minecraft.red_glazed_terracotta": "Roude gloasierde Keramig",
  "block.minecraft.red_mushroom": "Rouda Bilz",
  "block.minecraft.red_mushroom_block": "Rouda Bilzblogg",
  "block.minecraft.red_nether_brick_slab": "Roude Netherzieglschdufn",
  "block.minecraft.red_nether_brick_stairs": "Roude Netherziegldrebbn",
  "block.minecraft.red_nether_brick_wall": "Roude Netherzieglmaua",
  "block.minecraft.red_nether_bricks": "Rode Netherziegl",
  "block.minecraft.red_sand": "Rouda Sand",
  "block.minecraft.red_sandstone": "Rouda Sandschdoi",
  "block.minecraft.red_sandstone_slab": "Roude Sandschdoischdufn",
  "block.minecraft.red_sandstone_stairs": "Roude Sandschdoidrebbn",
  "block.minecraft.red_sandstone_wall": "Roude Sandschdoimaua",
  "block.minecraft.red_shulker_box": "Roude Shulkerkischdla",
  "block.minecraft.red_stained_glass": "Roudes Glos",
  "block.minecraft.red_stained_glass_pane": "Roude Glosschaim",
  "block.minecraft.red_terracotta": "Roude Keramig",
  "block.minecraft.red_tulip": "Roude Dulbn",
  "block.minecraft.red_wool": "Roude Woll",
  "block.minecraft.redstone_block": "Redstone-Blogg",
  "block.minecraft.redstone_lamp": "Redstone-Lambm",
  "block.minecraft.redstone_ore": "Redstone-Ätz",
  "block.minecraft.redstone_torch": "Redstone-Faggl",
  "block.minecraft.redstone_wall_torch": "Redstone-Wandfaggl",
  "block.minecraft.redstone_wire": "Redstone-Kobl",
  "block.minecraft.reinforced_deepslate": "Verstärggder Diefnschiefer",
  "block.minecraft.repeater": "Redstone-Verstärka",
  "block.minecraft.repeating_command_block": "Wiedahol-Bfehlsblogg",
  "block.minecraft.resin_block": "Block of Resin",
  "block.minecraft.resin_brick_slab": "Resin Brick Slab",
  "block.minecraft.resin_brick_stairs": "Resin Brick Stairs",
  "block.minecraft.resin_brick_wall": "Resin Brick Wall",
  "block.minecraft.resin_bricks": "Resin Bricks",
  "block.minecraft.resin_clump": "Resin Clump",
  "block.minecraft.respawn_anchor": "Seelnanka",
  "block.minecraft.rooted_dirt": "Wuazelerdn",
  "block.minecraft.rose_bush": "Rousnbischl",
  "block.minecraft.sand": "Sand",
  "block.minecraft.sandstone": "Sandschdoi",
  "block.minecraft.sandstone_slab": "Sandschdoischdufn",
  "block.minecraft.sandstone_stairs": "Sandschdoidrebbn",
  "block.minecraft.sandstone_wall": "Sandschdoimaua",
  "block.minecraft.scaffolding": "Grüsdd",
  "block.minecraft.sculk": "Sculk",
  "block.minecraft.sculk_catalyst": "Sculk-Gaddalisador",
  "block.minecraft.sculk_sensor": "Sculk-Sensoa",
  "block.minecraft.sculk_shrieker": "Sculk-Graner",
  "block.minecraft.sculk_vein": "Sculk-Ader",
  "block.minecraft.sea_lantern": "Seeladern",
  "block.minecraft.sea_pickle": "Seegurkn",
  "block.minecraft.seagrass": "Herbier",
  "block.minecraft.set_spawn": "Wiedaeinstigspunkd gsetzd",
  "block.minecraft.short_dry_grass": "Short Dry Grass",
  "block.minecraft.short_grass": "Short Grass",
  "block.minecraft.shroomlight": "Pilzliachd",
  "block.minecraft.shulker_box": "Shulkerkischdla",
  "block.minecraft.skeleton_skull": "Sgeleddschedl",
  "block.minecraft.skeleton_wall_skull": "Sgeledd-Wandschedl",
  "block.minecraft.slime_block": "Schloimblogg",
  "block.minecraft.small_amethyst_bud": "Glane Amethysdknosb",
  "block.minecraft.small_dripleaf": "Glanes Dropfbladd",
  "block.minecraft.smithing_table": "Schmiedetisch",
  "block.minecraft.smoker": "Räuchaofn",
  "block.minecraft.smooth_basalt": "Gladda Basald",
  "block.minecraft.smooth_quartz": "Gladda Kwarzblogg",
  "block.minecraft.smooth_quartz_slab": "Gladde Kwarzschdufn",
  "block.minecraft.smooth_quartz_stairs": "Gladde Kwarzdrebbn",
  "block.minecraft.smooth_red_sandstone": "Gladda rouda Sandschdoi",
  "block.minecraft.smooth_red_sandstone_slab": "Gladde roude Sandschdoischdufn",
  "block.minecraft.smooth_red_sandstone_stairs": "Gladde roude Sandschdoidrebbn",
  "block.minecraft.smooth_sandstone": "Gladda Sandschdoi",
  "block.minecraft.smooth_sandstone_slab": "Gladde Sandschdoischdufn",
  "block.minecraft.smooth_sandstone_stairs": "Gladde Sandschdoidrebbn",
  "block.minecraft.smooth_stone": "Gladda Schdoi",
  "block.minecraft.smooth_stone_slab": "Gladde Schdoischdufn",
  "block.minecraft.sniffer_egg": "Schnüffler-Ei",
  "block.minecraft.snow": "Schnäh",
  "block.minecraft.snow_block": "Schnähblogg",
  "block.minecraft.soul_campfire": "Seelnlagafeua",
  "block.minecraft.soul_fire": "Seelnfeua",
  "block.minecraft.soul_lantern": "Seelnlaterne",
  "block.minecraft.soul_sand": "Seelnsand",
  "block.minecraft.soul_soil": "Seelnerde",
  "block.minecraft.soul_torch": "Seelnfaggl",
  "block.minecraft.soul_wall_torch": "Seelnwandfaggl",
  "block.minecraft.spawn.not_valid": "Du hasd ka Bedd und kenen uffgladenen Seelnanka, oda dein Wiedaeinstiegspungd wuad blokierd",
  "block.minecraft.spawner": "Greadurrenerschaffer",
  "block.minecraft.spawner.desc1": "Inderaggzion mit am Erschaffungsei:",
  "block.minecraft.spawner.desc2": "Sets Mob Type",
  "block.minecraft.sponge": "Schwamm",
  "block.minecraft.spore_blossom": "Spoanblüde",
  "block.minecraft.spruce_button": "Fichdngnobf",
  "block.minecraft.spruce_door": "Fichdnhulzdüe",
  "block.minecraft.spruce_fence": "Fichdnhulzzou",
  "block.minecraft.spruce_fence_gate": "Fichdnhulzzauntor",
  "block.minecraft.spruce_hanging_sign": "Spruce Hanging Sign",
  "block.minecraft.spruce_leaves": "Fichdnnoadln",
  "block.minecraft.spruce_log": "Fichdnschdamm",
  "block.minecraft.spruce_planks": "Fichdnhulzbredda",
  "block.minecraft.spruce_pressure_plate": "Fichdnhulzdruggbladdn",
  "block.minecraft.spruce_sapling": "Fichdnsetzling",
  "block.minecraft.spruce_shelf": "Spruce Shelf",
  "block.minecraft.spruce_sign": "Fichdnhulzschild",
  "block.minecraft.spruce_slab": "Fichdnhulzschdufn",
  "block.minecraft.spruce_stairs": "Fichdnhulzdrebbn",
  "block.minecraft.spruce_trapdoor": "Fichdnhulzfalldüe",
  "block.minecraft.spruce_wall_hanging_sign": "Spruce Wall Hanging Sign",
  "block.minecraft.spruce_wall_sign": "Fichdnhulzwandschild",
  "block.minecraft.spruce_wood": "Fichdnhulz",
  "block.minecraft.sticky_piston": "Klebriga Kolbm",
  "block.minecraft.stone": "Schdoi",
  "block.minecraft.stone_brick_slab": "Schdoizieglschdufn",
  "block.minecraft.stone_brick_stairs": "Schdoiziegldrebbn",
  "block.minecraft.stone_brick_wall": "Schdazieglmaua",
  "block.minecraft.stone_bricks": "Stå Zeigel",
  "block.minecraft.stone_button": "Schdoignobf",
  "block.minecraft.stone_pressure_plate": "Staadruggbladdn",
  "block.minecraft.stone_slab": "Schdoischdufn",
  "block.minecraft.stone_stairs": "Schdoidrebbn",
  "block.minecraft.stonecutter": "Schdoisäch",
  "block.minecraft.stripped_acacia_log": "Endrindeda Akazienschdamm",
  "block.minecraft.stripped_acacia_wood": "Endrindeds Akazienhulz",
  "block.minecraft.stripped_bamboo_block": "Block of Stripped Bamboo",
  "block.minecraft.stripped_birch_log": "Endrindeda Berknschdamm",
  "block.minecraft.stripped_birch_wood": "Endrindeds Berknhulz",
  "block.minecraft.stripped_cherry_log": "Stripped Cherry Log",
  "block.minecraft.stripped_cherry_wood": "Stripped Cherry Wood",
  "block.minecraft.stripped_crimson_hyphae": "Geschälte Karmesinhyphen",
  "block.minecraft.stripped_crimson_stem": "Geschälter Karmesinstiel",
  "block.minecraft.stripped_dark_oak_log": "Endrindeda Schwoazächaschdamm",
  "block.minecraft.stripped_dark_oak_wood": "Endindeds Schwoazächahulz",
  "block.minecraft.stripped_jungle_log": "Endrindeda Droubnboamschdamm",
  "block.minecraft.stripped_jungle_wood": "Endrindeds Droubnhulz",
  "block.minecraft.stripped_mangrove_log": "Stripped Mangrove Log",
  "block.minecraft.stripped_mangrove_wood": "Stripped Mangrove Wood",
  "block.minecraft.stripped_oak_log": "Endrindeda Ächaschdamm",
  "block.minecraft.stripped_oak_wood": "Endindeds Ächahulz",
  "block.minecraft.stripped_pale_oak_log": "Stripped Pale Oak Log",
  "block.minecraft.stripped_pale_oak_wood": "Stripped Pale Oak Wood",
  "block.minecraft.stripped_spruce_log": "Endrindeda Fichdnschdamm",
  "block.minecraft.stripped_spruce_wood": "Endrindeds Fichdnhulz",
  "block.minecraft.stripped_warped_hyphae": "Geschälte Wirrhyphen",
  "block.minecraft.stripped_warped_stem": "Geschälter Wirrstiel",
  "block.minecraft.structure_block": "Konsdrugtiondsblogg",
  "block.minecraft.structure_void": "Konsdrugtiondsleere",
  "block.minecraft.sugar_cane": "Zuckarohr",
  "block.minecraft.sunflower": "Sunnebloeme",
  "block.minecraft.suspicious_gravel": "Suspicious Gravel",
  "block.minecraft.suspicious_sand": "Suspicious Sand",
  "block.minecraft.sweet_berry_bush": "Süßbeernschtrach",
  "block.minecraft.tall_dry_grass": "Tall Dry Grass",
  "block.minecraft.tall_grass": "Hoch’s Groos",
  "block.minecraft.tall_seagrass": "Hoch’s Seegroos",
  "block.minecraft.target": "Zielscheibenblogg",
  "block.minecraft.terracotta": "Keramig",
  "block.minecraft.test_block": "Test Block",
  "block.minecraft.test_instance_block": "Test Instance Block",
  "block.minecraft.tinted_glass": "Gfärbdes Glos",
  "block.minecraft.tnt": "DND",
  "block.minecraft.tnt.disabled": "TNT explosions are disabled",
  "block.minecraft.torch": "Faggl",
  "block.minecraft.torchflower": "Torchflower",
  "block.minecraft.torchflower_crop": "Torchflower Crop",
  "block.minecraft.trapped_chest": "Redstone-Druhe",
  "block.minecraft.trial_spawner": "Trial Spawner",
  "block.minecraft.tripwire": "Stolbadrahd",
  "block.minecraft.tripwire_hook": "Hakn",
  "block.minecraft.tube_coral": "Orgelgralle",
  "block.minecraft.tube_coral_block": "Orgelgrallnblogg",
  "block.minecraft.tube_coral_fan": "Orgelgrallnfächa",
  "block.minecraft.tube_coral_wall_fan": "Orgelgrallnwandfächa",
  "block.minecraft.tuff": "Duffstoa",
  "block.minecraft.tuff_brick_slab": "Tuff Brick Slab",
  "block.minecraft.tuff_brick_stairs": "Tuff Brick Stairs",
  "block.minecraft.tuff_brick_wall": "Tuff Brick Wall",
  "block.minecraft.tuff_bricks": "Tuff Bricks",
  "block.minecraft.tuff_slab": "Tuff Slab",
  "block.minecraft.tuff_stairs": "Tuff Stairs",
  "block.minecraft.tuff_wall": "Tuff Wall",
  "block.minecraft.turtle_egg": "Schildgrödnei",
  "block.minecraft.twisting_vines": "Zwiablrankn",
  "block.minecraft.twisting_vines_plant": "Zwiablranknpflanz",
  "block.minecraft.vault": "Vault",
  "block.minecraft.verdant_froglight": "Verdant Froglight",
  "block.minecraft.vine": "Rankn",
  "block.minecraft.void_air": "Leernlufd",
  "block.minecraft.wall_torch": "Kohlwandfaggl",
  "block.minecraft.warped_button": "Wirrknopf",
  "block.minecraft.warped_door": "Wirrdüe",
  "block.minecraft.warped_fence": "Wirrzaun",
  "block.minecraft.warped_fence_gate": "Wirrzaundüa",
  "block.minecraft.warped_fungus": "Wirrpilz",
  "block.minecraft.warped_hanging_sign": "Warped Hanging Sign",
  "block.minecraft.warped_hyphae": "Wirrhyphen",
  "block.minecraft.warped_nylium": "Wirr-Nezl",
  "block.minecraft.warped_planks": "Wirrbredda",
  "block.minecraft.warped_pressure_plate": "Wirrdruggbladdn",
  "block.minecraft.warped_roots": "Wirrwurzln",
  "block.minecraft.warped_shelf": "Warped Shelf",
  "block.minecraft.warped_sign": "Wirrschild",
  "block.minecraft.warped_slab": "Wirrschdufn",
  "block.minecraft.warped_stairs": "Wirrdrebbn",
  "block.minecraft.warped_stem": "Wirrstiel",
  "block.minecraft.warped_trapdoor": "Wirrfalldüe",
  "block.minecraft.warped_wall_hanging_sign": "Warped Wall Hanging Sign",
  "block.minecraft.warped_wall_sign": "Wirrwandschild",
  "block.minecraft.warped_wart_block": "Wirrwarznblogg",
  "block.minecraft.water": "Wassa",
  "block.minecraft.water_cauldron": "Wassagessl",
  "block.minecraft.waxed_chiseled_copper": "Waxed Chiseled Copper",
  "block.minecraft.waxed_copper_bars": "Waxed Copper Bars",
  "block.minecraft.waxed_copper_block": "Gwachsda Kupfablogg",
  "block.minecraft.waxed_copper_bulb": "Waxed Copper Bulb",
  "block.minecraft.waxed_copper_chain": "Waxed Copper Chain",
  "block.minecraft.waxed_copper_chest": "Waxed Copper Chest",
  "block.minecraft.waxed_copper_door": "Waxed Copper Door",
  "block.minecraft.waxed_copper_golem_statue": "Waxed Copper Golem Statue",
  "block.minecraft.waxed_copper_grate": "Waxed Copper Grate",
  "block.minecraft.waxed_copper_lantern": "Waxed Copper Lantern",
  "block.minecraft.waxed_copper_trapdoor": "Waxed Copper Trapdoor",
  "block.minecraft.waxed_cut_copper": "Gwachsda gschniddna Kupfablogg",
  "block.minecraft.waxed_cut_copper_slab": "Gwachste gschniddene Kupfaschdufn",
  "block.minecraft.waxed_cut_copper_stairs": "Gwachsde gschniddne Kupfadrebbn",
  "block.minecraft.waxed_exposed_chiseled_copper": "Waxed Exposed Chiseled Copper",
  "block.minecraft.waxed_exposed_copper": "Gwachsda anglaufna Kupfablogg",
  "block.minecraft.waxed_exposed_copper_bars": "Waxed Exposed Copper Bars",
  "block.minecraft.waxed_exposed_copper_bulb": "Waxed Exposed Copper Bulb",
  "block.minecraft.waxed_exposed_copper_chain": "Waxed Exposed Copper Chain",
  "block.minecraft.waxed_exposed_copper_chest": "Waxed Exposed Copper Chest",
  "block.minecraft.waxed_exposed_copper_door": "Waxed Exposed Copper Door",
  "block.minecraft.waxed_exposed_copper_golem_statue": "Waxed Exposed Copper Golem Statue",
  "block.minecraft.waxed_exposed_copper_grate": "Waxed Exposed Copper Grate",
  "block.minecraft.waxed_exposed_copper_lantern": "Waxed Exposed Copper Lantern",
  "block.minecraft.waxed_exposed_copper_trapdoor": "Waxed Exposed Copper Trapdoor",
  "block.minecraft.waxed_exposed_cut_copper": "Gwachsda anglaufna gschniddna Kupfablogg",
  "block.minecraft.waxed_exposed_cut_copper_slab": "Gwachste anglaufne gschniddene Kupfaschdufn",
  "block.minecraft.waxed_exposed_cut_copper_stairs": "Gwachsde anglaufne gschniddne Kupfadrebbn",
  "block.minecraft.waxed_exposed_lightning_rod": "Waxed Exposed Lightning Rod",
  "block.minecraft.waxed_lightning_rod": "Waxed Lightning Rod",
  "block.minecraft.waxed_oxidized_chiseled_copper": "Waxed Oxidized Chiseled Copper",
  "block.minecraft.waxed_oxidized_copper": "Gwachsda oxidieada Kupfablogg",
  "block.minecraft.waxed_oxidized_copper_bars": "Waxed Oxidized Copper Bars",
  "block.minecraft.waxed_oxidized_copper_bulb": "Waxed Oxidized Copper Bulb",
  "block.minecraft.waxed_oxidized_copper_chain": "Waxed Oxidized Copper Chain",
  "block.minecraft.waxed_oxidized_copper_chest": "Waxed Oxidized Copper Chest",
  "block.minecraft.waxed_oxidized_copper_door": "Waxed Oxidized Copper Door",
  "block.minecraft.waxed_oxidized_copper_golem_statue": "Waxed Oxidized Copper Golem Statue",
  "block.minecraft.waxed_oxidized_copper_grate": "Waxed Oxidized Copper Grate",
  "block.minecraft.waxed_oxidized_copper_lantern": "Waxed Oxidized Copper Lantern",
  "block.minecraft.waxed_oxidized_copper_trapdoor": "Waxed Oxidized Copper Trapdoor",
  "block.minecraft.waxed_oxidized_cut_copper": "Gwachsda oxidieada gschniddna Kupfablogg",
  "block.minecraft.waxed_oxidized_cut_copper_slab": "Gwachsde oxidieade gschniddne Kupfaschdufn",
  "block.minecraft.waxed_oxidized_cut_copper_stairs": "Gwachsde oxidieade gschniddne Kupfadrebbn",
  "block.minecraft.waxed_oxidized_lightning_rod": "Waxed Oxidized Lightning Rod",
  "block.minecraft.waxed_weathered_chiseled_copper": "Waxed Weathered Chiseled Copper",
  "block.minecraft.waxed_weathered_copper": "Gwachsda veawiddada Kupfablogg",
  "block.minecraft.waxed_weathered_copper_bars": "Waxed Weathered Copper Bars",
  "block.minecraft.waxed_weathered_copper_bulb": "Waxed Weathered Copper Bulb",
  "block.minecraft.waxed_weathered_copper_chain": "Waxed Weathered Copper Chain",
  "block.minecraft.waxed_weathered_copper_chest": "Waxed Weathered Copper Chest",
  "block.minecraft.waxed_weathered_copper_door": "Waxed Weathered Copper Door",
  "block.minecraft.waxed_weathered_copper_golem_statue": "Waxed Weathered Copper Golem Statue",
  "block.minecraft.waxed_weathered_copper_grate": "Waxed Weathered Copper Grate",
  "block.minecraft.waxed_weathered_copper_lantern": "Waxed Weathered Copper Lantern",
  "block.minecraft.waxed_weathered_copper_trapdoor": "Waxed Weathered Copper Trapdoor",
  "block.minecraft.waxed_weathered_cut_copper": "Gwachsda veawiddada gschniddna Kupfablogg",
  "block.minecraft.waxed_weathered_cut_copper_slab": "Gwachsde veawiddade gschniddne Kupfaschdufn",
  "block.minecraft.waxed_weathered_cut_copper_stairs": "Gwachsde veawiddade gschniddne Kupfadrebbn",
  "block.minecraft.waxed_weathered_lightning_rod": "Waxed Weathered Lightning Rod",
  "block.minecraft.weathered_chiseled_copper": "Weathered Chiseled Copper",
  "block.minecraft.weathered_copper": "Veawiddada Kupfablogg",
  "block.minecraft.weathered_copper_bars": "Weathered Copper Bars",
  "block.minecraft.weathered_copper_bulb": "Weathered Copper Bulb",
  "block.minecraft.weathered_copper_chain": "Weathered Copper Chain",
  "block.minecraft.weathered_copper_chest": "Weathered Copper Chest",
  "block.minecraft.weathered_copper_door": "Weathered Copper Door",
  "block.minecraft.weathered_copper_golem_statue": "Weathered Copper Golem Statue",
  "block.minecraft.weathered_copper_grate": "Weathered Copper Grate",
  "block.minecraft.weathered_copper_lantern": "Weathered Copper Lantern",
  "block.minecraft.weathered_copper_trapdoor": "Weathered Copper Trapdoor",
  "block.minecraft.weathered_cut_copper": "Veawiddada gschniddna Kupfablogg",
  "block.minecraft.weathered_cut_copper_slab": "Veawiddade gschniddne Kupfaschdufn",
  "block.minecraft.weathered_cut_copper_stairs": "Veawiddade gschniddne Kupfadrebbn",
  "block.minecraft.weathered_lightning_rod": "Weathered Lightning Rod",
  "block.minecraft.weeping_vines": "Trauerrankn",
  "block.minecraft.weeping_vines_plant": "Trauerranknpflanz",
  "block.minecraft.wet_sponge": "Nasser Schwamm",
  "block.minecraft.wheat": "Waiznpflanze",
  "block.minecraft.white_banner": "Woaßes Banner",
  "block.minecraft.white_bed": "Woaßes Bedd",
  "block.minecraft.white_candle": "Woeißa Kirza",
  "block.minecraft.white_candle_cake": "Kuchn midn woaßa Kirza",
  "block.minecraft.white_carpet": "Woaßa Debbich",
  "block.minecraft.white_concrete": "Woaßa Bedon",
  "block.minecraft.white_concrete_powder": "Woaßa Druggnbedon",
  "block.minecraft.white_glazed_terracotta": "Woaße gloasierde Keramig",
  "block.minecraft.white_shulker_box": "Woaße Shulkerkischdla",
  "block.minecraft.white_stained_glass": "Woaßes Glos",
  "block.minecraft.white_stained_glass_pane": "Woaße Glosschaim",
  "block.minecraft.white_terracotta": "Woaße Keramig",
  "block.minecraft.white_tulip": "Woaße Dulbn",
  "block.minecraft.white_wool": "Woaße Woll",
  "block.minecraft.wildflowers": "Wildflowers",
  "block.minecraft.wither_rose": "Witherrousn",
  "block.minecraft.wither_skeleton_skull": "Withersgeleddschedl",
  "block.minecraft.wither_skeleton_wall_skull": "Withersgeledd-Wandschedl",
  "block.minecraft.yellow_banner": "Gelbes Banner",
  "block.minecraft.yellow_bed": "Gelbes Bedd",
  "block.minecraft.yellow_candle": "Gelba Kirza",
  "block.minecraft.yellow_candle_cake": "Kuchn midn gelba Kirza",
  "block.minecraft.yellow_carpet": "Gelba Debbich",
  "block.minecraft.yellow_concrete": "Gelba Bedon",
  "block.minecraft.yellow_concrete_powder": "Gelba Druggnbedon",
  "block.minecraft.yellow_glazed_terracotta": "Gelbe gloasierde Keramig",
  "block.minecraft.yellow_shulker_box": "Gelbe Shulkerkischdla",
  "block.minecraft.yellow_stained_glass": "Gelbes Glos",
  "block.minecraft.yellow_stained_glass_pane": "Gelbe Glosschaim",
  "block.minecraft.yellow_terracotta": "Gelbe Keramig",
  "block.minecraft.yellow_wool": "Gelbe Woll",
  "block.minecraft.zombie_head": "Zombiekupf",
  "block.minecraft.zombie_wall_head": "Zombie-Wandkupf",
  "item.minecraft.acacia_boat": "Akazienhulzbood",
  "item.minecraft.acacia_chest_boat": "Acacia Boat with Chest",
  "item.minecraft.allay_spawn_egg": "Allay Spawn Egg",
  "item.minecraft.amethyst_shard": "Amethysdscherbn",
  "item.minecraft.angler_pottery_shard": "Angler Pottery Shard",
  "item.minecraft.angler_pottery_sherd": "Angler Pottery Sherd",
  "item.minecraft.apple": "Abfl",
  "item.minecraft.archer_pottery_shard": "Archer Pottery Shard",
  "item.minecraft.archer_pottery_sherd": "Archer Pottery Sherd",
  "item.minecraft.armadillo_scute": "Armadillo Scute",
  "item.minecraft.armadillo_spawn_egg": "Armadillo Spawn Egg",
  "item.minecraft.armor_stand": "Rüsdungsschdände",
  "item.minecraft.arms_up_pottery_shard": "Arms Up Pottery Shard",
  "item.minecraft.arms_up_pottery_sherd": "Arms Up Pottery Sherd",
  "item.minecraft.arrow": "Pfail",
  "item.minecraft.axolotl_bucket": "Axolodlaima",
  "item.minecraft.axolotl_spawn_egg": "Axolodl-Spawn-Gaggeli",
  "item.minecraft.baked_potato": "Ofnkadoffe",
  "item.minecraft.bamboo_chest_raft": "Bamboo Raft with Chest",
  "item.minecraft.bamboo_raft": "Bamboo Raft",
  "item.minecraft.bat_spawn_egg": "Fledamaus-Spawn-Gaggeli",
  "item.minecraft.bee_spawn_egg": "Bie-Spawn-Aa",
  "item.minecraft.beef": "Rohs Rindsfleisch",
  "item.minecraft.beetroot": "Roude Bede",
  "item.minecraft.beetroot_seeds": "Roude-Bede-Soma",
  "item.minecraft.beetroot_soup": "Borschtsch",
  "item.minecraft.birch_boat": "Berknhulzbood",
  "item.minecraft.birch_chest_boat": "Birch Boat with Chest",
  "item.minecraft.black_bundle": "Black Bundle",
  "item.minecraft.black_dye": "Schwoaza Fabbschdoff",
  "item.minecraft.black_harness": "Black Harness",
  "item.minecraft.blade_pottery_shard": "Blade Pottery Shard",
  "item.minecraft.blade_pottery_sherd": "Blade Pottery Sherd",
  "item.minecraft.blaze_powder": "Lohnschdaub",
  "item.minecraft.blaze_rod": "Lohnrude",
  "item.minecraft.blaze_spawn_egg": "Lohn-Spawn-Gaggeli",
  "item.minecraft.blue_bundle": "Blue Bundle",
  "item.minecraft.blue_dye": "Blaua Fabbschdoff",
  "item.minecraft.blue_egg": "Blue Egg",
  "item.minecraft.blue_harness": "Blue Harness",
  "item.minecraft.bogged_spawn_egg": "Bogged Spawn Egg",
  "item.minecraft.bolt_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.bolt_armor_trim_smithing_template.new": "Bolt Armor Trim",
  "item.minecraft.bone": "Gnochn",
  "item.minecraft.bone_meal": "Gnochnmehl",
  "item.minecraft.book": "Bouch",
  "item.minecraft.bordure_indented_banner_pattern": "Bordure Indented Banner Pattern",
  "item.minecraft.bow": "Boochn",
  "item.minecraft.bowl": "Schüssl",
  "item.minecraft.bread": "Weggla",
  "item.minecraft.breeze_rod": "Breeze Rod",
  "item.minecraft.breeze_spawn_egg": "Breeze Spawn Egg",
  "item.minecraft.brewer_pottery_shard": "Brewer Pottery Shard",
  "item.minecraft.brewer_pottery_sherd": "Brewer Pottery Sherd",
  "item.minecraft.brewing_stand": "Brewing Stand",
  "item.minecraft.brick": "Glodds",
  "item.minecraft.brown_bundle": "Brown Bundle",
  "item.minecraft.brown_dye": "Broauna Fabbschdoff",
  "item.minecraft.brown_egg": "Brown Egg",
  "item.minecraft.brown_harness": "Brown Harness",
  "item.minecraft.brush": "Brush",
  "item.minecraft.bucket": "Aima",
  "item.minecraft.bundle": "Bündl",
  "item.minecraft.bundle.empty": "Empty",
  "item.minecraft.bundle.empty.description": "Can hold a mixed stack of items",
  "item.minecraft.bundle.full": "Full",
  "item.minecraft.bundle.fullness": "%s/%s",
  "item.minecraft.burn_pottery_shard": "Burn Pottery Shard",
  "item.minecraft.burn_pottery_sherd": "Burn Pottery Sherd",
  "item.minecraft.camel_husk_spawn_egg": "Camel Husk Spawn Egg",
  "item.minecraft.camel_spawn_egg": "Camel Spawn Egg",
  "item.minecraft.carrot": "Karoddn",
  "item.minecraft.carrot_on_a_stick": "Karodde am Schdegge",
  "item.minecraft.cat_spawn_egg": "Koatzn-Spawn-Gaggeli",
  "item.minecraft.cauldron": "Cauldron",
  "item.minecraft.cave_spider_spawn_egg": "Höhlnschbinn-Spawn-Gaggeli",
  "item.minecraft.chainmail_boots": "Keddnschdiefl",
  "item.minecraft.chainmail_chestplate": "Keddnhemmd",
  "item.minecraft.chainmail_helmet": "Keddnhaum",
  "item.minecraft.chainmail_leggings": "Keddnhuus",
  "item.minecraft.charcoal": "Hulzkohl",
  "item.minecraft.cherry_boat": "Cherry Boat",
  "item.minecraft.cherry_chest_boat": "Cherry Boat with Chest",
  "item.minecraft.chest_minecart": "Lore mid Druhe",
  "item.minecraft.chicken": "Rohs Giegerla",
  "item.minecraft.chicken_spawn_egg": "Hüecher-Spawn-Gaggeli",
  "item.minecraft.chorus_fruit": "Chorusfruchd",
  "item.minecraft.clay_ball": "Tonklumbn",
  "item.minecraft.clock": "Uah",
  "item.minecraft.coal": "Kohl",
  "item.minecraft.coast_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.coast_armor_trim_smithing_template.new": "Coast Armor Trim",
  "item.minecraft.cocoa_beans": "Kakaobohnn",
  "item.minecraft.cod": "Roha Kabljau",
  "item.minecraft.cod_bucket": "Kabljauaima",
  "item.minecraft.cod_spawn_egg": "Kabljau-Spawn-Gaggeli",
  "item.minecraft.command_block_minecart": "Lore mid Bfehlsblogg",
  "item.minecraft.compass": "Gommbass",
  "item.minecraft.cooked_beef": "Schdeeg",
  "item.minecraft.cooked_chicken": "Giegerla",
  "item.minecraft.cooked_cod": "Gbradena Kabljau",
  "item.minecraft.cooked_mutton": "Gbratenes Hammlflaisch",
  "item.minecraft.cooked_porkchop": "Scheiferla",
  "item.minecraft.cooked_rabbit": "Gbratenes Kaniggl",
  "item.minecraft.cooked_salmon": "Gebrodna Laggs",
  "item.minecraft.cookie": "Blezla",
  "item.minecraft.copper_axe": "Copper Axe",
  "item.minecraft.copper_boots": "Copper Boots",
  "item.minecraft.copper_chestplate": "Copper Chestplate",
  "item.minecraft.copper_golem_spawn_egg": "Copper Golem Spawn Egg",
  "item.minecraft.copper_helmet": "Copper Helmet",
  "item.minecraft.copper_hoe": "Copper Hoe",
  "item.minecraft.copper_horse_armor": "Copper Horse Armor",
  "item.minecraft.copper_ingot": "Kupfaboa",
  "item.minecraft.copper_leggings": "Copper Leggings",
  "item.minecraft.copper_nautilus_armor": "Copper Nautilus Armor",
  "item.minecraft.copper_nugget": "Copper Nugget",
  "item.minecraft.copper_pickaxe": "Copper Pickaxe",
  "item.minecraft.copper_shovel": "Copper Shovel",
  "item.minecraft.copper_spear": "Copper Spear",
  "item.minecraft.copper_sword": "Copper Sword",
  "item.minecraft.cow_spawn_egg": "Kou-Spawn-Gaggeli",
  "item.minecraft.creaking_spawn_egg": "Creaking Spawn Egg",
  "item.minecraft.creeper_banner_pattern": "Bannermuschder",
  "item.minecraft.creeper_banner_pattern.desc": "Creeper",
  "item.minecraft.creeper_banner_pattern.new": "Creeper Charge Banner Pattern",
  "item.minecraft.creeper_spawn_egg": "Creeper-Spawn-Gaggeli",
  "item.minecraft.crossbow": "Aambrusd",
  "item.minecraft.crossbow.projectile": "Gschoss:",
  "item.minecraft.crossbow.projectile.multiple": "Projectile: %s x %s",
  "item.minecraft.crossbow.projectile.single": "Projectile: %s",
  "item.minecraft.cyan_bundle": "Cyan Bundle",
  "item.minecraft.cyan_dye": "Dürgisa Fabbschdoff",
  "item.minecraft.cyan_harness": "Cyan Harness",
  "item.minecraft.danger_pottery_shard": "Danger Pottery Shard",
  "item.minecraft.danger_pottery_sherd": "Danger Pottery Sherd",
  "item.minecraft.dark_oak_boat": "Schwoazächahulzbood",
  "item.minecraft.dark_oak_chest_boat": "Dark Oak Boat with Chest",
  "item.minecraft.debug_stick": "Debug-Schdegge",
  "item.minecraft.debug_stick.empty": "%s hod kane Bloggzuschdände",
  "item.minecraft.debug_stick.select": "'%s' ausgewähld (%s)",
  "item.minecraft.debug_stick.update": "\"%s\" is edzerdla %s",
  "item.minecraft.diamond": "Diormand",
  "item.minecraft.diamond_axe": "Diormandbarte",
  "item.minecraft.diamond_boots": "Diormandschdiefl",
  "item.minecraft.diamond_chestplate": "Diormandbruasdschild",
  "item.minecraft.diamond_helmet": "Diormandhelm",
  "item.minecraft.diamond_hoe": "Diormandhaue",
  "item.minecraft.diamond_horse_armor": "Diormandpfeddrüsdung",
  "item.minecraft.diamond_leggings": "Diormandboischuz",
  "item.minecraft.diamond_nautilus_armor": "Diamond Nautilus Armor",
  "item.minecraft.diamond_pickaxe": "Diormandpickl",
  "item.minecraft.diamond_shovel": "Diormandschaufl",
  "item.minecraft.diamond_spear": "Diamond Spear",
  "item.minecraft.diamond_sword": "Diormandschwerd",
  "item.minecraft.disc_fragment_5": "Disc Fragment",
  "item.minecraft.disc_fragment_5.desc": "Schallbladdn - 5",
  "item.minecraft.dolphin_spawn_egg": "Delfin-Spawn-Gaggeli",
  "item.minecraft.donkey_spawn_egg": "Esl-Spawn-Gaggeli",
  "item.minecraft.dragon_breath": "Drochnadem",
  "item.minecraft.dried_kelp": "Gdrocknedea Seedang",
  "item.minecraft.drowned_spawn_egg": "Erdrunggenen-Spawn-Gaggeli",
  "item.minecraft.dune_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.dune_armor_trim_smithing_template.new": "Dune Armor Trim",
  "item.minecraft.echo_shard": "Echo Shard",
  "item.minecraft.egg": "Gaggeli",
  "item.minecraft.elder_guardian_spawn_egg": "Großa-Wächda-Spawn-Gaggeli",
  "item.minecraft.elytra": "Elydre",
  "item.minecraft.emerald": "Stala",
  "item.minecraft.enchanted_book": "Verzauberds Bouch",
  "item.minecraft.enchanted_golden_apple": "Verzauberda goidena Abfl",
  "item.minecraft.end_crystal": "Endergrissdall",
  "item.minecraft.ender_dragon_spawn_egg": "Ender Dragon Spawn Egg",
  "item.minecraft.ender_eye": "Enderach",
  "item.minecraft.ender_pearl": "Enderbeale",
  "item.minecraft.enderman_spawn_egg": "Enderman-Spawn-Gaggeli",
  "item.minecraft.endermite_spawn_egg": "Endermidn-Spawn-Gaggeli",
  "item.minecraft.evoker_spawn_egg": "Mogie-Spawn-Gaggeli",
  "item.minecraft.experience_bottle": "Eafohrungsfläschla",
  "item.minecraft.explorer_pottery_shard": "Explorer Pottery Shard",
  "item.minecraft.explorer_pottery_sherd": "Explorer Pottery Sherd",
  "item.minecraft.eye_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.eye_armor_trim_smithing_template.new": "Eye Armor Trim",
  "item.minecraft.feather": "Feda",
  "item.minecraft.fermented_spider_eye": "Fermendiedes Schbinnaach",
  "item.minecraft.field_masoned_banner_pattern": "Field Masoned Banner Pattern",
  "item.minecraft.filled_map": "Kadde",
  "item.minecraft.fire_charge": "Feuabool",
  "item.minecraft.firework_rocket": "Feuaweaksrachede",
  "item.minecraft.firework_rocket.flight": "Fluchdaue:",
  "item.minecraft.firework_rocket.multiple_stars": "%s x %s",
  "item.minecraft.firework_rocket.single_star": "%s",
  "item.minecraft.firework_star": "Feuaweaksschdean",
  "item.minecraft.firework_star.black": "Schwoaz",
  "item.minecraft.firework_star.blue": "Blau",
  "item.minecraft.firework_star.brown": "Broaun",
  "item.minecraft.firework_star.custom_color": "Custom",
  "item.minecraft.firework_star.cyan": "Dürgis",
  "item.minecraft.firework_star.fade_to": "Übagang zu",
  "item.minecraft.firework_star.flicker": "Funggln",
  "item.minecraft.firework_star.gray": "Grau",
  "item.minecraft.firework_star.green": "Grin",
  "item.minecraft.firework_star.light_blue": "Hellblau",
  "item.minecraft.firework_star.light_gray": "Hellgrau",
  "item.minecraft.firework_star.lime": "Hellgrin",
  "item.minecraft.firework_star.magenta": "Magenda",
  "item.minecraft.firework_star.orange": "Orange",
  "item.minecraft.firework_star.pink": "Bingg",
  "item.minecraft.firework_star.purple": "Violedd",
  "item.minecraft.firework_star.red": "Roud",
  "item.minecraft.firework_star.shape": "Unbegannde Fom",
  "item.minecraft.firework_star.shape.burst": "Exblosion",
  "item.minecraft.firework_star.shape.creeper": "Creeperfemich",
  "item.minecraft.firework_star.shape.large_ball": "Große Kugl",
  "item.minecraft.firework_star.shape.small_ball": "Glane Kugl",
  "item.minecraft.firework_star.shape.star": "Schdeanfemich",
  "item.minecraft.firework_star.trail": "Schweif",
  "item.minecraft.firework_star.white": "Woaß",
  "item.minecraft.firework_star.yellow": "Gelb",
  "item.minecraft.fishing_rod": "Angl",
  "item.minecraft.flint": "Feuasta",
  "item.minecraft.flint_and_steel": "Feuazeuch",
  "item.minecraft.flow_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.flow_armor_trim_smithing_template.new": "Flow Armor Trim",
  "item.minecraft.flow_banner_pattern": "Banner Pattern",
  "item.minecraft.flow_banner_pattern.desc": "Flow",
  "item.minecraft.flow_banner_pattern.new": "Flow Banner Pattern",
  "item.minecraft.flow_pottery_sherd": "Flow Pottery Sherd",
  "item.minecraft.flower_banner_pattern": "Banner Pattern",
  "item.minecraft.flower_banner_pattern.desc": "Bluma",
  "item.minecraft.flower_banner_pattern.new": "Flower Charge Banner Pattern",
  "item.minecraft.flower_pot": "Flower Pot",
  "item.minecraft.fox_spawn_egg": "Fuchs-Spawn-Gaggeli",
  "item.minecraft.friend_pottery_shard": "Friend Pottery Shard",
  "item.minecraft.friend_pottery_sherd": "Friend Pottery Sherd",
  "item.minecraft.frog_spawn_egg": "Frog Spawn Egg",
  "item.minecraft.furnace_minecart": "Lore mid Ofn",
  "item.minecraft.ghast_spawn_egg": "Ghast-Spawn-Gaggeli",
  "item.minecraft.ghast_tear": "Ghastdräne",
  "item.minecraft.glass_bottle": "Glosbuddel",
  "item.minecraft.glistering_melon_slice": "Glitzende Melonscheim",
  "item.minecraft.globe_banner_pattern": "Banner Pattern",
  "item.minecraft.globe_banner_pattern.desc": "Globus",
  "item.minecraft.globe_banner_pattern.new": "Globe Banner Pattern",
  "item.minecraft.glow_berries": "Leuchdbeean",
  "item.minecraft.glow_ink_sac": "Leuchddindnbeudl",
  "item.minecraft.glow_item_frame": "Leuchdrahmn",
  "item.minecraft.glow_squid_spawn_egg": "Leuchddindnfisch-Spawn-Gaggeli",
  "item.minecraft.glowstone_dust": "Leuchdstaastaab",
  "item.minecraft.goat_horn": "Goat Horn",
  "item.minecraft.goat_spawn_egg": "Ziegn-Spawn-Gaggeli",
  "item.minecraft.gold_ingot": "Goidboa",
  "item.minecraft.gold_nugget": "Goidglumbn",
  "item.minecraft.golden_apple": "Goidena Abfl",
  "item.minecraft.golden_axe": "Goidbarte",
  "item.minecraft.golden_boots": "Goidschdiefl",
  "item.minecraft.golden_carrot": "Goidene Karoddn",
  "item.minecraft.golden_chestplate": "Goidbruasdschild",
  "item.minecraft.golden_helmet": "Goidhelm",
  "item.minecraft.golden_hoe": "Goidhaue",
  "item.minecraft.golden_horse_armor": "Goidene Pfeddrüsdung",
  "item.minecraft.golden_leggings": "Goidboischuz",
  "item.minecraft.golden_nautilus_armor": "Golden Nautilus Armor",
  "item.minecraft.golden_pickaxe": "Goidpickl",
  "item.minecraft.golden_shovel": "Goidschaufl",
  "item.minecraft.golden_spear": "Golden Spear",
  "item.minecraft.golden_sword": "Goidschwerd",
  "item.minecraft.gray_bundle": "Gray Bundle",
  "item.minecraft.gray_dye": "Graua Fabbschdoff",
  "item.minecraft.gray_harness": "Gray Harness",
  "item.minecraft.green_bundle": "Green Bundle",
  "item.minecraft.green_dye": "Grina Fabbschdoff",
  "item.minecraft.green_harness": "Green Harness",
  "item.minecraft.guardian_spawn_egg": "Wächda-Spawn-Gaggeli",
  "item.minecraft.gunpowder": "Schwoazbulva",
  "item.minecraft.guster_banner_pattern": "Banner Pattern",
  "item.minecraft.guster_banner_pattern.desc": "Guster",
  "item.minecraft.guster_banner_pattern.new": "Guster Banner Pattern",
  "item.minecraft.guster_pottery_sherd": "Guster Pottery Sherd",
  "item.minecraft.happy_ghast_spawn_egg": "Happy Ghast Spawn Egg",
  "item.minecraft.harness": "Harness",
  "item.minecraft.heart_of_the_sea": "Hätz vom Meer",
  "item.minecraft.heart_pottery_shard": "Heart Pottery Shard",
  "item.minecraft.heart_pottery_sherd": "Heart Pottery Sherd",
  "item.minecraft.heartbreak_pottery_shard": "Heartbreak Pottery Shard",
  "item.minecraft.heartbreak_pottery_sherd": "Heartbreak Pottery Sherd",
  "item.minecraft.hoglin_spawn_egg": "Hoglin-Spawn-Gaggeli",
  "item.minecraft.honey_bottle": "Honichbuddel",
  "item.minecraft.honeycomb": "Honichwòwe",
  "item.minecraft.hopper_minecart": "Lore mid Drichda",
  "item.minecraft.horse_spawn_egg": "Gaul-Spawn-Gaggeli",
  "item.minecraft.host_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.host_armor_trim_smithing_template.new": "Host Armor Trim",
  "item.minecraft.howl_pottery_shard": "Howl Pottery Shard",
  "item.minecraft.howl_pottery_sherd": "Howl Pottery Sherd",
  "item.minecraft.husk_spawn_egg": "Wüsdnzombie-Spawn-Gaggeli",
  "item.minecraft.ink_sac": "Dindnsagg",
  "item.minecraft.iron_axe": "Aasnbarte",
  "item.minecraft.iron_boots": "Aasnschdiefl",
  "item.minecraft.iron_chestplate": "Aasnbruasdschild",
  "item.minecraft.iron_golem_spawn_egg": "Iron Golem Spawn Egg",
  "item.minecraft.iron_helmet": "Aasnhelm",
  "item.minecraft.iron_hoe": "Aasnhaue",
  "item.minecraft.iron_horse_armor": "Aasne Pfeddrüsdung",
  "item.minecraft.iron_ingot": "Aasnboa",
  "item.minecraft.iron_leggings": "Aasnboischuz",
  "item.minecraft.iron_nautilus_armor": "Iron Nautilus Armor",
  "item.minecraft.iron_nugget": "Aasnglumbn",
  "item.minecraft.iron_pickaxe": "Aasnpickl",
  "item.minecraft.iron_shovel": "Aasnschaufl",
  "item.minecraft.iron_spear": "Iron Spear",
  "item.minecraft.iron_sword": "Aasnschwerd",
  "item.minecraft.item_frame": "Rahmn",
  "item.minecraft.jungle_boat": "Droubnhulzbood",
  "item.minecraft.jungle_chest_boat": "Jungle Boat with Chest",
  "item.minecraft.knowledge_book": "Bouch des Wissns",
  "item.minecraft.lapis_lazuli": "Labislazuli",
  "item.minecraft.lava_bucket": "Lovaaima",
  "item.minecraft.lead": "Laine",
  "item.minecraft.leather": "Ledda",
  "item.minecraft.leather_boots": "Leddaschdiefl",
  "item.minecraft.leather_chestplate": "Leddajäggle",
  "item.minecraft.leather_helmet": "Leddakappn",
  "item.minecraft.leather_horse_armor": "Leddane Pfeddrüsdung",
  "item.minecraft.leather_leggings": "Leddahuus",
  "item.minecraft.light_blue_bundle": "Light Blue Bundle",
  "item.minecraft.light_blue_dye": "Hellblaua Fabbschdoff",
  "item.minecraft.light_blue_harness": "Light Blue Harness",
  "item.minecraft.light_gray_bundle": "Light Gray Bundle",
  "item.minecraft.light_gray_dye": "Hellgraua Fabbschdoff",
  "item.minecraft.light_gray_harness": "Light Gray Harness",
  "item.minecraft.lime_bundle": "Lime Bundle",
  "item.minecraft.lime_dye": "Hellgrina Fabbschdoff",
  "item.minecraft.lime_harness": "Lime Harness",
  "item.minecraft.lingering_potion": "Veaweildrangg",
  "item.minecraft.lingering_potion.effect.awkward": "Seldsama Veaweildrangg",
  "item.minecraft.lingering_potion.effect.empty": "Ned brauchbara Veaweildrangg",
  "item.minecraft.lingering_potion.effect.fire_resistance": "Veaweildrangg dea Feuaresisdenz",
  "item.minecraft.lingering_potion.effect.harming": "Veaweildrangg des Schadns",
  "item.minecraft.lingering_potion.effect.healing": "Veaweildrangg dea Hailung",
  "item.minecraft.lingering_potion.effect.infested": "Lingering Potion of Infestation",
  "item.minecraft.lingering_potion.effect.invisibility": "Veaweildrangg dea Unsichdbakeid",
  "item.minecraft.lingering_potion.effect.leaping": "Veaweildrangg dea Sprungkrafd",
  "item.minecraft.lingering_potion.effect.levitation": "Veaweildrangg dea Schwebekrafd",
  "item.minecraft.lingering_potion.effect.luck": "Veaweildrangg des Glücks",
  "item.minecraft.lingering_potion.effect.mundane": "Gwöhnlicha Veaweildrangg",
  "item.minecraft.lingering_potion.effect.night_vision": "Veaweildrangg dea Nachdsichd",
  "item.minecraft.lingering_potion.effect.oozing": "Lingering Potion of Oozing",
  "item.minecraft.lingering_potion.effect.poison": "Veaweildrangg dea Veagifdung",
  "item.minecraft.lingering_potion.effect.regeneration": "Veaweildrangg dea Regeneration",
  "item.minecraft.lingering_potion.effect.slow_falling": "Veaweildrangg des sanfdn Fallns",
  "item.minecraft.lingering_potion.effect.slowness": "Veaweildrangg dea Langsamkeid",
  "item.minecraft.lingering_potion.effect.strength": "Veaweildrangg dea Stärkn",
  "item.minecraft.lingering_potion.effect.swiftness": "Veaweildrangg dea Schnellichkeid",
  "item.minecraft.lingering_potion.effect.thick": "Dickflüssiga Veaweildrangg",
  "item.minecraft.lingering_potion.effect.turtle_master": "Veaweildrangg des Schildkrödnmaistas",
  "item.minecraft.lingering_potion.effect.water": "Veaweilnde Wassabuddel",
  "item.minecraft.lingering_potion.effect.water_breathing": "Veaweildrangg dea Undawassaadmung",
  "item.minecraft.lingering_potion.effect.weakness": "Veaweildrangg dea Schwächn",
  "item.minecraft.lingering_potion.effect.weaving": "Lingering Potion of Weaving",
  "item.minecraft.lingering_potion.effect.wind_charged": "Lingering Potion of Wind Charging",
  "item.minecraft.llama_spawn_egg": "Loma-Spawn-Gaggeli",
  "item.minecraft.lodestone_compass": "Leidstoa-Kombass",
  "item.minecraft.mace": "Mace",
  "item.minecraft.magenta_bundle": "Magenta Bundle",
  "item.minecraft.magenta_dye": "Magenda Fabbschdoff",
  "item.minecraft.magenta_harness": "Magenta Harness",
  "item.minecraft.magma_cream": "Mochmagreem",
  "item.minecraft.magma_cube_spawn_egg": "Mochmawüffel-Spawn-Gaggeli",
  "item.minecraft.mangrove_boat": "Mangrove Boat",
  "item.minecraft.mangrove_chest_boat": "Mangrove Boat with Chest",
  "item.minecraft.map": "Leere Kadde",
  "item.minecraft.melon_seeds": "Melonsoma",
  "item.minecraft.melon_slice": "Melonscheim",
  "item.minecraft.milk_bucket": "Milliaima",
  "item.minecraft.minecart": "Lore",
  "item.minecraft.miner_pottery_shard": "Miner Pottery Shard",
  "item.minecraft.miner_pottery_sherd": "Miner Pottery Sherd",
  "item.minecraft.mojang_banner_pattern": "Banner Pattern",
  "item.minecraft.mojang_banner_pattern.desc": "Mojang-Logo",
  "item.minecraft.mojang_banner_pattern.new": "Thing Banner Pattern",
  "item.minecraft.mooshroom_spawn_egg": "Mooshroom-Spawn-Gaggeli",
  "item.minecraft.mourner_pottery_shard": "Mourner Pottery Shard",
  "item.minecraft.mourner_pottery_sherd": "Mourner Pottery Sherd",
  "item.minecraft.mule_spawn_egg": "Mauldier-Spawn-Gaggeli",
  "item.minecraft.mushroom_stew": "Bilzsubbn",
  "item.minecraft.music_disc_11": "Schallbladdn",
  "item.minecraft.music_disc_11.desc": "C418 - 11",
  "item.minecraft.music_disc_13": "Schallbladdn",
  "item.minecraft.music_disc_13.desc": "C418 - 13",
  "item.minecraft.music_disc_5": "Schallbladdn",
  "item.minecraft.music_disc_5.desc": "Samuel Åberg - 5",
  "item.minecraft.music_disc_blocks": "Schallbladdn",
  "item.minecraft.music_disc_blocks.desc": "C418 - blocks",
  "item.minecraft.music_disc_cat": "Schallbladdn",
  "item.minecraft.music_disc_cat.desc": "C418 - cat",
  "item.minecraft.music_disc_chirp": "Schallbladdn",
  "item.minecraft.music_disc_chirp.desc": "C418 - chirp",
  "item.minecraft.music_disc_creator": "Music Disc",
  "item.minecraft.music_disc_creator.desc": "Lena Raine - Creator",
  "item.minecraft.music_disc_creator_music_box": "Music Disc",
  "item.minecraft.music_disc_creator_music_box.desc": "Lena Raine - Creator (Music Box)",
  "item.minecraft.music_disc_far": "Schallbladdn",
  "item.minecraft.music_disc_far.desc": "C418 - far",
  "item.minecraft.music_disc_lava_chicken": "Music Disc",
  "item.minecraft.music_disc_lava_chicken.desc": "Hyper Potions - Lava Chicken",
  "item.minecraft.music_disc_mall": "Schallbladdn",
  "item.minecraft.music_disc_mall.desc": "C418 - mall",
  "item.minecraft.music_disc_mellohi": "Schallbladdn",
  "item.minecraft.music_disc_mellohi.desc": "C418 - mellohi",
  "item.minecraft.music_disc_otherside": "Schallbladdn",
  "item.minecraft.music_disc_otherside.desc": "Lena Raine - otherside",
  "item.minecraft.music_disc_pigstep": "Schallbladdn",
  "item.minecraft.music_disc_pigstep.desc": "Lena Raine - Pigstep",
  "item.minecraft.music_disc_precipice": "Music Disc",
  "item.minecraft.music_disc_precipice.desc": "Aaron Cherof - Precipice",
  "item.minecraft.music_disc_relic": "Music Disc",
  "item.minecraft.music_disc_relic.desc": "Aaron Cherof - Relic",
  "item.minecraft.music_disc_stal": "Schallbladdn",
  "item.minecraft.music_disc_stal.desc": "C418 - stal",
  "item.minecraft.music_disc_strad": "Schallbladdn",
  "item.minecraft.music_disc_strad.desc": "C418 - strad",
  "item.minecraft.music_disc_tears": "Music Disc",
  "item.minecraft.music_disc_tears.desc": "Amos Roddy - Tears",
  "item.minecraft.music_disc_wait": "Schallbladdn",
  "item.minecraft.music_disc_wait.desc": "C418 - wait",
  "item.minecraft.music_disc_ward": "Schallbladdn",
  "item.minecraft.music_disc_ward.desc": "C418 - ward",
  "item.minecraft.mutton": "Rohes Hammlflaisch",
  "item.minecraft.name_tag": "Noamensschild",
  "item.minecraft.nautilus_shell": "Naudilusschole",
  "item.minecraft.nautilus_spawn_egg": "Nautilus Spawn Egg",
  "item.minecraft.nether_brick": "Netherglödds",
  "item.minecraft.nether_star": "Netherschdean",
  "item.minecraft.nether_wart": "Nether Wart",
  "item.minecraft.netherite_axe": "Netheritaxn",
  "item.minecraft.netherite_boots": "Netheritschdiefl",
  "item.minecraft.netherite_chestplate": "Netheritbruasdschild",
  "item.minecraft.netherite_helmet": "Netherithelm",
  "item.minecraft.netherite_hoe": "Netherithaue",
  "item.minecraft.netherite_horse_armor": "Netherite Horse Armor",
  "item.minecraft.netherite_ingot": "Netheritboa",
  "item.minecraft.netherite_leggings": "Netheritboischuz",
  "item.minecraft.netherite_nautilus_armor": "Netherite Nautilus Armor",
  "item.minecraft.netherite_pickaxe": "Netheritspitzhackn",
  "item.minecraft.netherite_scrap": "Netheritbladdn",
  "item.minecraft.netherite_shovel": "Netheritschaufl",
  "item.minecraft.netherite_spear": "Netherite Spear",
  "item.minecraft.netherite_sword": "Netheritschwead",
  "item.minecraft.netherite_upgrade_smithing_template": "Smithing Template",
  "item.minecraft.netherite_upgrade_smithing_template.new": "Netherite Upgrade",
  "item.minecraft.oak_boat": "Ächahulzbood",
  "item.minecraft.oak_chest_boat": "Oak Boat with Chest",
  "item.minecraft.ocelot_spawn_egg": "Ozelodn-Spawn-Gaggeli",
  "item.minecraft.ominous_bottle": "Ominous Bottle",
  "item.minecraft.ominous_trial_key": "Ominous Trial Key",
  "item.minecraft.orange_bundle": "Orange Bundle",
  "item.minecraft.orange_dye": "Oranga Fabbschdoff",
  "item.minecraft.orange_harness": "Orange Harness",
  "item.minecraft.painting": "Zeichnung",
  "item.minecraft.pale_oak_boat": "Pale Oak Boat",
  "item.minecraft.pale_oak_chest_boat": "Pale Oak Boat with Chest",
  "item.minecraft.panda_spawn_egg": "Poanda-Spawn-Gaggeli",
  "item.minecraft.paper": "Babier",
  "item.minecraft.parched_spawn_egg": "Parched Spawn Egg",
  "item.minecraft.parrot_spawn_egg": "Babagein-Spawn-Gaggeli",
  "item.minecraft.phantom_membrane": "Phandomhaud",
  "item.minecraft.phantom_spawn_egg": "Phandom-Spawn-Gaggeli",
  "item.minecraft.pig_spawn_egg": "Schweins-Spawn-Ei",
  "item.minecraft.piglin_banner_pattern": "Banner Pattern",
  "item.minecraft.piglin_banner_pattern.desc": "Schnauzn",
  "item.minecraft.piglin_banner_pattern.new": "Snout Banner Pattern",
  "item.minecraft.piglin_brute_spawn_egg": "Piglin-Babarn-Spawn-Gaggeli",
  "item.minecraft.piglin_spawn_egg": "Piglin-Spawn-Gaggeli",
  "item.minecraft.pillager_spawn_egg": "Blündera-Spawn-Gaggeli",
  "item.minecraft.pink_bundle": "Pink Bundle",
  "item.minecraft.pink_dye": "Bingga Fabbschdoff",
  "item.minecraft.pink_harness": "Pink Harness",
  "item.minecraft.pitcher_plant": "Pitcher Plant",
  "item.minecraft.pitcher_pod": "Pitcher Pod",
  "item.minecraft.plenty_pottery_shard": "Plenty Pottery Shard",
  "item.minecraft.plenty_pottery_sherd": "Plenty Pottery Sherd",
  "item.minecraft.poisonous_potato": "Giffdiche Kadoffe",
  "item.minecraft.polar_bear_spawn_egg": "Eisbeä-Spawn-Gaggeli",
  "item.minecraft.popped_chorus_fruit": "Geblatzde Chorusfruchd",
  "item.minecraft.porkchop": "Rohs Schweinsflasch",
  "item.minecraft.potato": "Kadoffe",
  "item.minecraft.potion": "Drangg",
  "item.minecraft.potion.effect.awkward": "Seldsama Drangg",
  "item.minecraft.potion.effect.empty": "Net brauchbara Drangg",
  "item.minecraft.potion.effect.fire_resistance": "Drangg dea Feuaresisdenz",
  "item.minecraft.potion.effect.harming": "Drangg des Schadns",
  "item.minecraft.potion.effect.healing": "Drangg dea Hailung",
  "item.minecraft.potion.effect.infested": "Potion of Infestation",
  "item.minecraft.potion.effect.invisibility": "Drangg dea Unsichdbakeid",
  "item.minecraft.potion.effect.leaping": "Drangg dea Sprungkrafd",
  "item.minecraft.potion.effect.levitation": "Drangg dea Schwebekrafd",
  "item.minecraft.potion.effect.luck": "Drangg des Glücks",
  "item.minecraft.potion.effect.mundane": "Gwöhnlicha Drangg",
  "item.minecraft.potion.effect.night_vision": "Drangg dea Nachdsichd",
  "item.minecraft.potion.effect.oozing": "Potion of Oozing",
  "item.minecraft.potion.effect.poison": "Drangg dea Veagifdung",
  "item.minecraft.potion.effect.regeneration": "Drangg dea Regeneration",
  "item.minecraft.potion.effect.slow_falling": "Drangg des sanfdn Fallns",
  "item.minecraft.potion.effect.slowness": "Drangg dea Langsamkeid",
  "item.minecraft.potion.effect.strength": "Drangg dea Stärkn",
  "item.minecraft.potion.effect.swiftness": "Drangg dea Schnellichkeid",
  "item.minecraft.potion.effect.thick": "Dickflüssiga Drangg",
  "item.minecraft.potion.effect.turtle_master": "Drangg des Schildkrödnmaistas",
  "item.minecraft.potion.effect.water": "Wassabuddel",
  "item.minecraft.potion.effect.water_breathing": "Drangg dea Undawassaadmung",
  "item.minecraft.potion.effect.weakness": "Drangg dea Schwächn",
  "item.minecraft.potion.effect.weaving": "Potion of Weaving",
  "item.minecraft.potion.effect.wind_charged": "Potion of Wind Charging",
  "item.minecraft.pottery_shard_archer": "Archer Pottery Shard",
  "item.minecraft.pottery_shard_arms_up": "Arms Up Pottery Shard",
  "item.minecraft.pottery_shard_prize": "Prize Pottery Shard",
  "item.minecraft.pottery_shard_skull": "Skull Pottery Shard",
  "item.minecraft.powder_snow_bucket": "Bulverschnähaima",
  "item.minecraft.prismarine_crystals": "Brismaringrissdall",
  "item.minecraft.prismarine_shard": "Brismarinscherbm",
  "item.minecraft.prize_pottery_shard": "Prize Pottery Shard",
  "item.minecraft.prize_pottery_sherd": "Prize Pottery Sherd",
  "item.minecraft.pufferfish": "Kuglfisch",
  "item.minecraft.pufferfish_bucket": "Kuglfischaima",
  "item.minecraft.pufferfish_spawn_egg": "Kuglfisch-Spawn-Gaggeli",
  "item.minecraft.pumpkin_pie": "Kärwiskuchn",
  "item.minecraft.pumpkin_seeds": "Kärwissoma",
  "item.minecraft.purple_bundle": "Purple Bundle",
  "item.minecraft.purple_dye": "Violedda Fabbschdoff",
  "item.minecraft.purple_harness": "Purple Harness",
  "item.minecraft.quartz": "Netherkwarz",
  "item.minecraft.rabbit": "Rohes Kaniggl",
  "item.minecraft.rabbit_foot": "Kanigglpfode",
  "item.minecraft.rabbit_hide": "Kanigglfell",
  "item.minecraft.rabbit_spawn_egg": "Karnickel-Spawn-Gaggeli",
  "item.minecraft.rabbit_stew": "Kanigglragout",
  "item.minecraft.raiser_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.raiser_armor_trim_smithing_template.new": "Raiser Armor Trim",
  "item.minecraft.ravager_spawn_egg": "Vawüsda-Spawn-Gaggeli",
  "item.minecraft.raw_copper": "Rohkupfa",
  "item.minecraft.raw_gold": "Rohgold",
  "item.minecraft.raw_iron": "Rohaasn",
  "item.minecraft.recovery_compass": "Recovery Compass",
  "item.minecraft.red_bundle": "Red Bundle",
  "item.minecraft.red_dye": "Rouda Fabbschdoff",
  "item.minecraft.red_harness": "Red Harness",
  "item.minecraft.redstone": "Redstone-Staab",
  "item.minecraft.resin_brick": "Resin Brick",
  "item.minecraft.resin_clump": "Resin Clump",
  "item.minecraft.rib_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.rib_armor_trim_smithing_template.new": "Rib Armor Trim",
  "item.minecraft.rotten_flesh": "Varoddedes Fleisch",
  "item.minecraft.saddle": "Saddl",
  "item.minecraft.salmon": "Rohe Laggs",
  "item.minecraft.salmon_bucket": "Laggsaima",
  "item.minecraft.salmon_spawn_egg": "Laggs-Spawn-Gaggeli",
  "item.minecraft.scrape_pottery_sherd": "Scrape Pottery Sherd",
  "item.minecraft.scute": "Scute",
  "item.minecraft.sentry_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.sentry_armor_trim_smithing_template.new": "Sentry Armor Trim",
  "item.minecraft.shaper_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.shaper_armor_trim_smithing_template.new": "Shaper Armor Trim",
  "item.minecraft.sheaf_pottery_shard": "Sheaf Pottery Shard",
  "item.minecraft.sheaf_pottery_sherd": "Sheaf Pottery Sherd",
  "item.minecraft.shears": "Scher",
  "item.minecraft.sheep_spawn_egg": "Hämml-Spawn-Gaggeli",
  "item.minecraft.shelter_pottery_shard": "Shelter Pottery Shard",
  "item.minecraft.shelter_pottery_sherd": "Shelter Pottery Sherd",
  "item.minecraft.shield": "Schild",
  "item.minecraft.shield.black": "Schwoaza Schild",
  "item.minecraft.shield.blue": "Blaua Schild",
  "item.minecraft.shield.brown": "Broauna Schild",
  "item.minecraft.shield.cyan": "Dürgisa Schild",
  "item.minecraft.shield.gray": "Graua Schild",
  "item.minecraft.shield.green": "Grina Schild",
  "item.minecraft.shield.light_blue": "Hellblaua Schild",
  "item.minecraft.shield.light_gray": "Hellgraua Schild",
  "item.minecraft.shield.lime": "Hellgrina Schild",
  "item.minecraft.shield.magenta": "Magenda Schild",
  "item.minecraft.shield.orange": "Oranga Schild",
  "item.minecraft.shield.pink": "Bingga Schild",
  "item.minecraft.shield.purple": "Violedda Schild",
  "item.minecraft.shield.red": "Rouda Schild",
  "item.minecraft.shield.white": "Woaßa Schild",
  "item.minecraft.shield.yellow": "Gelba Schild",
  "item.minecraft.shulker_shell": "Shulkerschole",
  "item.minecraft.shulker_spawn_egg": "Shulker-Spawn-Gaggeli",
  "item.minecraft.sign": "Sign",
  "item.minecraft.silence_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.silence_armor_trim_smithing_template.new": "Silence Armor Trim",
  "item.minecraft.silverfish_spawn_egg": "Silbefisch-Spawn-Gaggeli",
  "item.minecraft.skeleton_horse_spawn_egg": "Sgeleddgaul-Spawn-Gaggeli",
  "item.minecraft.skeleton_spawn_egg": "Sgeledd-Spawn-Gaggeli",
  "item.minecraft.skull_banner_pattern": "Banner Pattern",
  "item.minecraft.skull_banner_pattern.desc": "Schedl",
  "item.minecraft.skull_banner_pattern.new": "Skull Charge Banner Pattern",
  "item.minecraft.skull_pottery_shard": "Skull Pottery Shard",
  "item.minecraft.skull_pottery_sherd": "Skull Pottery Sherd",
  "item.minecraft.slime_ball": "Schloimbool",
  "item.minecraft.slime_spawn_egg": "Schloim-Spawn-Gaggeli",
  "item.minecraft.smithing_template": "Smithing Template",
  "item.minecraft.smithing_template.applies_to": "Applies to:",
  "item.minecraft.smithing_template.armor_trim.additions_slot_description": "Add ingot or crystal",
  "item.minecraft.smithing_template.armor_trim.applies_to": "Armor",
  "item.minecraft.smithing_template.armor_trim.base_slot_description": "Add a piece of armor",
  "item.minecraft.smithing_template.armor_trim.ingredients": "Ingots & Crystals",
  "item.minecraft.smithing_template.ingredients": "Ingredients:",
  "item.minecraft.smithing_template.netherite_upgrade.additions_slot_description": "Add Netherite Ingot",
  "item.minecraft.smithing_template.netherite_upgrade.applies_to": "Diamond Equipment",
  "item.minecraft.smithing_template.netherite_upgrade.base_slot_description": "Add diamond armor, weapon, or tool",
  "item.minecraft.smithing_template.netherite_upgrade.ingredients": "Netherite Ingot",
  "item.minecraft.smithing_template.upgrade": "Upgrade: ",
  "item.minecraft.sniffer_spawn_egg": "Sniffer Spawn Egg",
  "item.minecraft.snort_pottery_shard": "Snort Pottery Shard",
  "item.minecraft.snort_pottery_sherd": "Snort Pottery Sherd",
  "item.minecraft.snout_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.snout_armor_trim_smithing_template.new": "Snout Armor Trim",
  "item.minecraft.snow_golem_spawn_egg": "Snow Golem Spawn Egg",
  "item.minecraft.snowball": "Schnähbool",
  "item.minecraft.spectral_arrow": "Spekdralpfail",
  "item.minecraft.spider_eye": "Schbinnaach",
  "item.minecraft.spider_spawn_egg": "Schbinn-Spawn-Gaggeli",
  "item.minecraft.spire_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.spire_armor_trim_smithing_template.new": "Spire Armor Trim",
  "item.minecraft.splash_potion": "Wuafdrangg",
  "item.minecraft.splash_potion.effect.awkward": "Seldsama Wuafdrangg",
  "item.minecraft.splash_potion.effect.empty": "Net brauchbara Drangg",
  "item.minecraft.splash_potion.effect.fire_resistance": "Wuafdrangg dea Feuaresisdenz",
  "item.minecraft.splash_potion.effect.harming": "Wuafdrangg des Schadns",
  "item.minecraft.splash_potion.effect.healing": "Wuafdrangg dea Hailung",
  "item.minecraft.splash_potion.effect.infested": "Splash Potion of Infestation",
  "item.minecraft.splash_potion.effect.invisibility": "Wuafdrangg dea Unsichdbakeid",
  "item.minecraft.splash_potion.effect.leaping": "Wuafdrangg dea Sprungkrafd",
  "item.minecraft.splash_potion.effect.levitation": "Wuafdrangg dea Schwebekrafd",
  "item.minecraft.splash_potion.effect.luck": "Wuafdrangg des Glücks",
  "item.minecraft.splash_potion.effect.mundane": "Gwöhnlicha Wuafdrangg",
  "item.minecraft.splash_potion.effect.night_vision": "Wuafdrangg dea Nachdsichd",
  "item.minecraft.splash_potion.effect.oozing": "Splash Potion of Oozing",
  "item.minecraft.splash_potion.effect.poison": "Wuafdrangg dea Veagifdung",
  "item.minecraft.splash_potion.effect.regeneration": "Wuafdrangg dea Regeneration",
  "item.minecraft.splash_potion.effect.slow_falling": "Wuafdrangg des sanfdn Fallns",
  "item.minecraft.splash_potion.effect.slowness": "Wuafdrangg dea Langsamkeid",
  "item.minecraft.splash_potion.effect.strength": "Wuafdrangg dea Stärkn",
  "item.minecraft.splash_potion.effect.swiftness": "Wuadrangg dea Schnellichkeid",
  "item.minecraft.splash_potion.effect.thick": "Dickflüssiga Wuafdrangg",
  "item.minecraft.splash_potion.effect.turtle_master": "Wuafdrangg des Schildkrödnmaistas",
  "item.minecraft.splash_potion.effect.water": "Weafbare Wassabuddel",
  "item.minecraft.splash_potion.effect.water_breathing": "Wuafdrangg dea Undawassaadmung",
  "item.minecraft.splash_potion.effect.weakness": "Wuafdrangg dea Schwächn",
  "item.minecraft.splash_potion.effect.weaving": "Splash Potion of Weaving",
  "item.minecraft.splash_potion.effect.wind_charged": "Splash Potion of Wind Charging",
  "item.minecraft.spruce_boat": "Fichdnhulzbood",
  "item.minecraft.spruce_chest_boat": "Spruce Boat with Chest",
  "item.minecraft.spyglass": "Feanroa",
  "item.minecraft.squid_spawn_egg": "Dindnfisch-Spawn-Gaggeli",
  "item.minecraft.stick": "Schdegge",
  "item.minecraft.stone_axe": "Schdoibarte",
  "item.minecraft.stone_hoe": "Schdoihaue",
  "item.minecraft.stone_pickaxe": "Schdoipickl",
  "item.minecraft.stone_shovel": "Schdoischaufl",
  "item.minecraft.stone_spear": "Stone Spear",
  "item.minecraft.stone_sword": "Staanschwerd",
  "item.minecraft.stray_spawn_egg": "Aiswandra-Spawn-Gaggeli",
  "item.minecraft.strider_spawn_egg": "Schreida-Spawn-Gaggeli",
  "item.minecraft.string": "Foudn",
  "item.minecraft.sugar": "Zugga",
  "item.minecraft.suspicious_stew": "Seldsame Suppn",
  "item.minecraft.sweet_berries": "Süßbeean",
  "item.minecraft.tadpole_bucket": "Bucket of Tadpole",
  "item.minecraft.tadpole_spawn_egg": "Tadpole Spawn Egg",
  "item.minecraft.tide_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.tide_armor_trim_smithing_template.new": "Tide Armor Trim",
  "item.minecraft.tipped_arrow": "Gdränkda Pfail",
  "item.minecraft.tipped_arrow.effect.awkward": "Tipped Arrow",
  "item.minecraft.tipped_arrow.effect.empty": "Ned heastellbara gdränkda Pfail",
  "item.minecraft.tipped_arrow.effect.fire_resistance": "Pfail dea Feuaresisdenz",
  "item.minecraft.tipped_arrow.effect.harming": "Pfail des Schadns",
  "item.minecraft.tipped_arrow.effect.healing": "Pfail dea Hailung",
  "item.minecraft.tipped_arrow.effect.infested": "Arrow of Infestation",
  "item.minecraft.tipped_arrow.effect.invisibility": "Pfail dea Unsichdbakeid",
  "item.minecraft.tipped_arrow.effect.leaping": "Pfail dea Sprungkrafd",
  "item.minecraft.tipped_arrow.effect.levitation": "Pfail dea Schwebekrafd",
  "item.minecraft.tipped_arrow.effect.luck": "Pfail des Glücks",
  "item.minecraft.tipped_arrow.effect.mundane": "Tipped Arrow",
  "item.minecraft.tipped_arrow.effect.night_vision": "Pfail dea Nachdsichd",
  "item.minecraft.tipped_arrow.effect.oozing": "Arrow of Oozing",
  "item.minecraft.tipped_arrow.effect.poison": "Pfail dea Veagifdung",
  "item.minecraft.tipped_arrow.effect.regeneration": "Pfail dea Regeneration",
  "item.minecraft.tipped_arrow.effect.slow_falling": "Pfail des sanfdn Fallns",
  "item.minecraft.tipped_arrow.effect.slowness": "Pfail dea Langsamkeid",
  "item.minecraft.tipped_arrow.effect.strength": "Pfail dea Stärkn",
  "item.minecraft.tipped_arrow.effect.swiftness": "Pfail dea Schnelligkeid",
  "item.minecraft.tipped_arrow.effect.thick": "Tipped Arrow",
  "item.minecraft.tipped_arrow.effect.turtle_master": "Pfail des Schildkrödnmaistas",
  "item.minecraft.tipped_arrow.effect.water": "Nassa Pfail",
  "item.minecraft.tipped_arrow.effect.water_breathing": "Pfail dea Undawassaadmung",
  "item.minecraft.tipped_arrow.effect.weakness": "Pfail dea Schwächn",
  "item.minecraft.tipped_arrow.effect.weaving": "Arrow of Weaving",
  "item.minecraft.tipped_arrow.effect.wind_charged": "Arrow of Wind Charging",
  "item.minecraft.tnt_minecart": "Lore mid DND",
  "item.minecraft.torchflower_seeds": "Torchflower Seeds",
  "item.minecraft.totem_of_undying": "Dodem der Unschdebblichgaad",
  "item.minecraft.trader_llama_spawn_egg": "Händlaloma-Spawn-Gaggeli",
  "item.minecraft.trial_key": "Trial Key",
  "item.minecraft.trident": "Draizagg",
  "item.minecraft.tropical_fish": "Drobnfisch",
  "item.minecraft.tropical_fish_bucket": "Drobnfischaima",
  "item.minecraft.tropical_fish_spawn_egg": "Drobnfisch-Spawn-Gaggeli",
  "item.minecraft.turtle_helmet": "Schildgrödnbanza",
  "item.minecraft.turtle_scute": "Turtle Scute",
  "item.minecraft.turtle_spawn_egg": "Schildgrödn-Spawn-Gaggeli",
  "item.minecraft.vex_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.vex_armor_trim_smithing_template.new": "Vex Armor Trim",
  "item.minecraft.vex_spawn_egg": "Gschbensd-Spawn-Gaggeli",
  "item.minecraft.villager_spawn_egg": "Doefbewohne-Spawn-Gaggeli",
  "item.minecraft.vindicator_spawn_egg": "Diena-Spawn-Gaggeli",
  "item.minecraft.wandering_trader_spawn_egg": "Fahrnda-Händla-Spawn-Gaggeli",
  "item.minecraft.ward_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.ward_armor_trim_smithing_template.new": "Ward Armor Trim",
  "item.minecraft.warden_spawn_egg": "Warden Spawn Egg",
  "item.minecraft.warped_fungus_on_a_stick": "Wirrpilzrudn",
  "item.minecraft.water_bucket": "Wassaaima",
  "item.minecraft.wayfinder_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.wayfinder_armor_trim_smithing_template.new": "Wayfinder Armor Trim",
  "item.minecraft.wheat": "Waaz",
  "item.minecraft.wheat_seeds": "Waiznköana",
  "item.minecraft.white_bundle": "White Bundle",
  "item.minecraft.white_dye": "Woaßa Fabbschdoff",
  "item.minecraft.white_harness": "White Harness",
  "item.minecraft.wild_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.wild_armor_trim_smithing_template.new": "Wild Armor Trim",
  "item.minecraft.wind_charge": "Wind Charge",
  "item.minecraft.witch_spawn_egg": "Affarlaa-Spawn-Gaggeli",
  "item.minecraft.wither_skeleton_spawn_egg": "Withersgeledd-Spawn-Gaggeli",
  "item.minecraft.wither_spawn_egg": "Wither Spawn Egg",
  "item.minecraft.wolf_armor": "Wolf Armor",
  "item.minecraft.wolf_spawn_egg": "Wolf-Spawn-Gaggeli",
  "item.minecraft.wooden_axe": "Hulzbarte",
  "item.minecraft.wooden_hoe": "Hulzhaue",
  "item.minecraft.wooden_pickaxe": "Hulzpickl",
  "item.minecraft.wooden_shovel": "Hulzschaufl",
  "item.minecraft.wooden_spear": "Wooden Spear",
  "item.minecraft.wooden_sword": "Hulzschwerd",
  "item.minecraft.writable_book": "Bouch mid Fede",
  "item.minecraft.written_book": "Beschriebens Bouch",
  "item.minecraft.yellow_bundle": "Yellow Bundle",
  "item.minecraft.yellow_dye": "Gelba Fabbschdoff",
  "item.minecraft.yellow_harness": "Yellow Harness",
  "item.minecraft.zoglin_spawn_egg": "Zoglin-Spawn-Gaggeli",
  "item.minecraft.zombie_horse_spawn_egg": "Zombiegaul-Spawn-Gaggeli",
  "item.minecraft.zombie_nautilus_spawn_egg": "Zombie Nautilus Spawn Egg",
  "item.minecraft.zombie_spawn_egg": "Zombie-Spawn-Gaggeli",
  "item.minecraft.zombie_villager_spawn_egg": "Zombiedoefbewohne-Spawn-Gaggeli",
  "item.minecraft.zombified_piglin_spawn_egg": "Zombifizieada-Piglin-Spawn-Gaggeli"
}
export const fra_de = items; 
